<div class="bsp-rind-page" [formGroup]="form">
    <h1>Biosicherheitsplan Rind</h1>
    <ng-container *kienePermission="[1255]">
        <div class="tierarzt-row">
            <kiene-autocomplete
                (elementSelected)="setTierarzt($event)"
                [disabled]="isReadOnly() || isSaving"
                [displayFields]="['vorname', 'nachname']"
                [focus]="tierarztId != null"
                [genericApiUrl]="'tierarzt/read_autocomplete.php'"
                [kieneObject]="currentVet"
                [placeholder]="'Tierarzt'"
                class="tierarzt-autocomplete"
            ></kiene-autocomplete>
        </div>
    </ng-container>
    <div class="header-row">
        <h2>1. Angaben zum Betrieb/Betriebsstätte, betriebsindividuelle Risikofaktoren</h2>
    </div>
    <div class="workflow-row card">
        <div class="workflow-status">
            <strong>Status:</strong> {{ getStatusLabel() }}
            <span *ngIf="isSaving"> - wird gespeichert...</span>
        </div>
        <div class="workflow-actions">
            <kiene-sign-button
                [disabled]="!bsId || isSaving || isAlreadySigned()"
                [buttonText]="signButtonLabel"
                [kuid]="planKuid"
                [tierarzt_id]="tierarztIdForSign"
                [kunde_id]="kundeIdForSign"
                (kuid)="persistKuidToPlan($event)"
                (signDialogClosed)="onSignDialogClosed()"
            ></kiene-sign-button>
            <button
                *kienePermission="[110024]"
                mat-raised-button
                color="accent"
                type="button"
                (click)="abschliessen()"
                [disabled]="!bsId || isSaving || statusId === 232 || statusId === 250 || statusId === 251"
            >
                Abschließen
            </button>
            <button
                *ngIf="statusId === 251 && localStorageService.hasPermission(110026)"
                mat-stroked-button
                type="button"
                (click)="setBeantragtStatus(231)"
                [disabled]="!bsId || isSaving"
            >
                Zurück auf erstellt
            </button>
        </div>
    </div>
    <div class="simple-row">
        <mat-form-field appearance="outline">
            <mat-label>TSK-Nr(n).</mat-label>
            <input matInput formControlName="tskNummern" />
            <button
                *ngIf="localStorageService.hasPermission(110028)"
                mat-icon-button
                matSuffix
                type="button"
                (click)="openTSKDialog()"
                aria-label="TSK-Nummer nachtragen"
            >
                <mat-icon>add</mat-icon>
            </button>
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>Registriernr(n). (VVVO)</mat-label>
            <input matInput formControlName="registriernummern" />
        </mat-form-field>
    </div>

    <div class="besteuerung-row">
        <span class="besteuerung-label">Besteuerung</span>
        <mat-radio-group formControlName="besteuerung">
            <mat-radio-button value="optierend">optierend</mat-radio-button>
            <mat-radio-button value="pauschal">pauschal</mat-radio-button>
        </mat-radio-group>
    </div>

    <div class="grid-2-col">
        <section class="card" formGroupName="betrieb">
            <h3>Betrieb</h3>
            <div class="person-grid">
                <mat-form-field appearance="outline">
                    <mat-label>Name</mat-label>
                    <input matInput formControlName="name" />
                </mat-form-field>
                <mat-form-field appearance="outline">
                    <mat-label>Vorname</mat-label>
                    <input matInput formControlName="vorname" />
                </mat-form-field>
                <mat-form-field appearance="outline">
                    <mat-label>PLZ</mat-label>
                    <input matInput formControlName="plz" />
                </mat-form-field>
                <mat-form-field appearance="outline">
                    <mat-label>Ort</mat-label>
                    <input matInput formControlName="ort" />
                </mat-form-field>
                <mat-form-field appearance="outline">
                    <mat-label>Straße</mat-label>
                    <input matInput formControlName="strasse" />
                </mat-form-field>
                <mat-form-field appearance="outline">
                    <mat-label>Hausnummer</mat-label>
                    <input matInput formControlName="hausnummer" />
                </mat-form-field>
                <mat-form-field appearance="outline">
                    <mat-label>Telefon</mat-label>
                    <input matInput formControlName="telefon" />
                </mat-form-field>
                <mat-form-field appearance="outline">
                    <mat-label>E-Mail</mat-label>
                    <input matInput type="email" formControlName="email" />
                </mat-form-field>
            </div>
        </section>

        <section class="card" formGroupName="verantwortlichePerson">
            <h3>Verantwortliche Person</h3>
            <div class="person-grid">
                <mat-form-field appearance="outline">
                    <mat-label>Name</mat-label>
                    <input matInput formControlName="name" />
                </mat-form-field>
                <mat-form-field appearance="outline">
                    <mat-label>Vorname</mat-label>
                    <input matInput formControlName="vorname" />
                </mat-form-field>
                <mat-form-field appearance="outline">
                    <mat-label>PLZ</mat-label>
                    <input matInput formControlName="plz" />
                </mat-form-field>
                <mat-form-field appearance="outline">
                    <mat-label>Ort</mat-label>
                    <input matInput formControlName="ort" />
                </mat-form-field>
                <mat-form-field appearance="outline">
                    <mat-label>Straße</mat-label>
                    <input matInput formControlName="strasse" />
                </mat-form-field>
                <mat-form-field appearance="outline">
                    <mat-label>Hausnummer</mat-label>
                    <input matInput formControlName="hausnummer" />
                </mat-form-field>
                <mat-form-field appearance="outline">
                    <mat-label>Telefon</mat-label>
                    <input matInput formControlName="telefon" />
                </mat-form-field>
                <mat-form-field appearance="outline">
                    <mat-label>E-Mail</mat-label>
                    <input matInput type="email" formControlName="email" />
                </mat-form-field>
            </div>
        </section>
    </div>

    <div class="grid-2-col section-two">
        <section class="card" formGroupName="angabenBetrieb">
            <h3>1.1 Angaben zum Betrieb</h3>
            <div class="section-grid-1">
                <mat-form-field appearance="outline">
                    <mat-label>Anschrift des Betriebsstandortes (soweit abweichend)</mat-label>
                    <input matInput formControlName="anschriftBetriebsstandortAbweichend" />
                </mat-form-field>
                <mat-form-field appearance="outline">
                    <mat-label>Anzahl Ställe mit Stallbezeichnung</mat-label>
                    <input matInput formControlName="anzahlStaelleMitStallbezeichnung" />
                </mat-form-field>
                <mat-form-field appearance="outline">
                    <mat-label>Anzahl der Rinder zum Zeitpunkt der Bearbeitung</mat-label>
                    <input matInput formControlName="anzahlRinderZumZeitpunktBearbeitung" />
                </mat-form-field>
            </div>
        </section>

        <section class="card" formGroupName="tieraerztlicheBetreuung">
            <h3>1.2 Angaben zur tierärztlichen Betreuung</h3>
            <p class="subline">
                Die tierärztliche Betreuung und Beratung für den Biosicherheitsmanagementplan erfolgt durch folgende
                Tierarztpraxis:
            </p>
            <div class="section-grid-2">
                <mat-form-field appearance="outline">
                    <mat-label>Name</mat-label>
                    <input matInput formControlName="name" />
                </mat-form-field>
                <mat-form-field appearance="outline">
                    <mat-label>Anschrift</mat-label>
                    <input matInput formControlName="anschrift" />
                </mat-form-field>
                <mat-form-field appearance="outline">
                    <mat-label>VVVO-Nr.</mat-label>
                    <input matInput formControlName="vvvoNr" />
                </mat-form-field>
                <div class="betreuungsvertrag">
                    <label>Betreuungs-Vertrag</label>
                    <mat-radio-group formControlName="betreuungsvertrag">
                        <mat-radio-button [value]="true">Ja</mat-radio-button>
                        <mat-radio-button [value]="false">Nein</mat-radio-button>
                    </mat-radio-group>
                </div>
            </div>
        </section>
    </div>

    <section class="card section-three" formGroupName="tierhaltung">
        <h3>1.3 Angaben zur Tierhaltung</h3>

        <div class="tierhaltung-grid">
            <div class="subsection top" formGroupName="produktionsverfahren">
                <h4>Produktionsverfahren (Mehrfachnennungen möglich)</h4>
                <div class="checkbox-grid four-cols">
                    <mat-checkbox formControlName="rindermast">Rindermast</mat-checkbox>
                    <mat-checkbox formControlName="fresseraufzucht">Fresseraufzucht</mat-checkbox>
                    <mat-checkbox formControlName="milchmast">Milchmast</mat-checkbox>
                    <mat-checkbox formControlName="roesemast">Rosémast</mat-checkbox>
                    <mat-checkbox formControlName="mutterkuhhaltung">Mutterkuhhaltung</mat-checkbox>
                    <mat-checkbox formControlName="milchviehhaltung">Milchviehhaltung</mat-checkbox>
                    <mat-checkbox formControlName="jungrinderaufzucht">Jungrinderaufzucht</mat-checkbox>
                    <mat-checkbox formControlName="pensionsviehhaltung">Pensionsviehhaltung</mat-checkbox>
                </div>
                <div class="inline-with-field">
                    <mat-checkbox formControlName="sonstiges">Sonstiges</mat-checkbox>
                    <mat-form-field appearance="outline">
                        <mat-label>Bitte angeben</mat-label>
                        <input matInput formControlName="sonstigesText" />
                    </mat-form-field>
                </div>
            </div>

            <div class="subsection top" formGroupName="artWeiseHaltung">
                <h4>Art und Weise der Haltung</h4>
                <div class="checkbox-grid three-cols">
                    <mat-checkbox formControlName="reinRaus">rein/raus</mat-checkbox>
                    <mat-checkbox formControlName="abteilweiseStallweise">abteilweise / stallweise</mat-checkbox>
                    <mat-checkbox formControlName="kontinuierlich">kontinuierlich</mat-checkbox>
                    <mat-checkbox formControlName="mitLaufhof">mit Laufhof</mat-checkbox>
                </div>
                <div class="inline-with-field">
                    <mat-checkbox formControlName="weidehaltung">Weidehaltung</mat-checkbox>
                    <mat-form-field appearance="outline">
                        <mat-label>saisonal / ganzjährig</mat-label>
                        <input matInput formControlName="weidehaltungDetails" />
                    </mat-form-field>
                </div>
            </div>

            <div class="subsection bottom" formGroupName="weitereTierhaltungen">
                <h4>Weitere Tierhaltungen</h4>
                <div class="checkbox-grid three-cols">
                    <mat-checkbox formControlName="gefluegel">Geflügel</mat-checkbox>
                    <mat-checkbox formControlName="schafeZiegen">Schafe/Ziegen</mat-checkbox>
                    <mat-checkbox formControlName="schweine">Schweine</mat-checkbox>
                </div>
                <div class="inline-with-field two-rows">
                    <mat-checkbox formControlName="sonstigeWiederkaeuer">Sonstige Wiederkäuer</mat-checkbox>
                    <mat-form-field appearance="outline">
                        <mat-label>Welche?</mat-label>
                        <input matInput formControlName="sonstigeWiederkaeuerText" />
                    </mat-form-field>
                </div>
                <div class="inline-with-field two-rows">
                    <mat-checkbox formControlName="andereNutztierarten">Andere Nutztierarten</mat-checkbox>
                    <mat-form-field appearance="outline">
                        <mat-label>Welche?</mat-label>
                        <input matInput formControlName="andereNutztierartenText" />
                    </mat-form-field>
                </div>
            </div>

            <div class="subsection bottom" formGroupName="zukauf">
                <h4>Zukauf</h4>
                <div class="radio-with-input">
                    <mat-radio-group formControlName="aktiv">
                        <mat-radio-button [value]="true">Ja</mat-radio-button>
                        <mat-radio-button [value]="false">Nein</mat-radio-button>
                    </mat-radio-group>
                    <mat-form-field appearance="outline">
                        <mat-label>Anzahl Herkunftsbetriebe</mat-label>
                        <input matInput formControlName="anzahlHerkunftsbetriebe" />
                    </mat-form-field>
                </div>
            </div>

            <div class="subsection bottom">
                <h4>Externe Jungviehaufzucht bei Milchviehhaltung</h4>
                <mat-radio-group formControlName="externeJungviehaufzuchtBeiMilchviehhaltung">
                    <mat-radio-button [value]="true">Ja</mat-radio-button>
                    <mat-radio-button [value]="false">Nein</mat-radio-button>
                </mat-radio-group>
            </div>
        </div>
    </section>

    <section class="card section-four" formGroupName="risikofaktorenLage">
        <h3>1.4 Betriebsindividuelle Risikofaktoren, die sich z. B. aus der Lage des Betriebes ergeben</h3>

        <div class="risk-layout-grid">
            <div class="risk-col">
                <div class="subsection top" formGroupName="gelaendelage">
                    <h4>In welchem Gelände liegt der Betrieb?</h4>
                    <div class="checkbox-grid two-cols">
                        <mat-checkbox formControlName="innerorts">Lage innerorts</mat-checkbox>
                        <mat-checkbox formControlName="ausserorts">Lage außerorts</mat-checkbox>
                    </div>
                </div>
                <div class="subsection bottom" formGroupName="verbindungenAndereBetriebe">
                    <h4>Hat der Betrieb Verbindungen zu anderen Betrieben?</h4>
                    <div class="frage-row">
                        <mat-radio-group formControlName="vorhanden">
                            <mat-radio-button [value]="true">Ja</mat-radio-button>
                            <mat-radio-button [value]="false">Nein</mat-radio-button>
                        </mat-radio-group>
                    </div>
                    <div class="if-yes-block" formGroupName="details">
                        <h4>Wenn ja, welche?</h4>
                        <div class="checkbox-grid two-cols">
                            <mat-checkbox formControlName="tiere">Verbringungen von Tieren</mat-checkbox>
                            <mat-checkbox formControlName="einstreuFuttermittel"
                                >Verbringungen von Einstreu/Futtermitteln</mat-checkbox
                            >
                            <mat-checkbox formControlName="betreuungspersonal">Betreuungspersonal</mat-checkbox>
                            <mat-checkbox formControlName="betriebsfahrzeuge">Betriebsfahrzeuge</mat-checkbox>
                            <mat-checkbox formControlName="geraetschaften">Gemeinsam genutzte Gerätschaften</mat-checkbox>
                            <mat-checkbox formControlName="treibwege">Gemeinsam genutzte Treibwege</mat-checkbox>
                        </div>
                        <div class="inline-with-field no-top-gap">
                            <mat-checkbox formControlName="sonstige">Sonstige Verbindungen</mat-checkbox>
                            <mat-form-field appearance="outline">
                                <mat-label>Wenn ja, welche?</mat-label>
                                <input matInput formControlName="sonstigeText" />
                            </mat-form-field>
                        </div>
                    </div>
                </div>

                <div class="subsection bottom" formGroupName="fremdarbeitskraefte">
                    <h4>Gibt es Fremdarbeitskräfte?</h4>
                    <mat-radio-group formControlName="vorhanden">
                        <mat-radio-button [value]="false">Nein</mat-radio-button>
                        <mat-radio-button [value]="true">Ja</mat-radio-button>
                    </mat-radio-group>

                    <div class="if-yes-block">
                        <h4>Wenn ja, haben diese außerhalb des Betriebes Kontakt zu Rindern oder anderen Wiederkäuern?</h4>
                        <div class="radio-with-input">
                            <mat-radio-group formControlName="kontaktZuWiederkaeuern">
                                <mat-radio-button [value]="false">Nein</mat-radio-button>
                                <mat-radio-button [value]="true">Ja</mat-radio-button>
                            </mat-radio-group>
                            <mat-form-field appearance="outline">
                                <mat-label>Art von Kontakt</mat-label>
                                <input matInput formControlName="kontaktart" />
                            </mat-form-field>
                        </div>
                    </div>
                </div>
            </div>

            <div class="risk-col">
                <div class="subsection top" formGroupName="betriebsstaetten">
                    <h4>Hat der Betrieb eine oder mehrere Betriebsstätten?</h4>
                    <mat-form-field appearance="outline" class="compact-field">
                        <mat-label>Anzahl</mat-label>
                        <input matInput formControlName="anzahl" />
                    </mat-form-field>

                    <div class="frage-row">
                        <span>Gibt es Verbindungen zwischen diesen Betriebsstätten?</span>
                        <mat-radio-group formControlName="verbindungenZwischen">
                            <mat-radio-button [value]="true">Ja</mat-radio-button>
                            <mat-radio-button [value]="false">Nein</mat-radio-button>
                        </mat-radio-group>
                    </div>

                    <div class="if-yes-block" formGroupName="verbindungen">
                        <h4>Wenn ja, welche?</h4>
                        <div class="checkbox-grid two-cols">
                            <mat-checkbox formControlName="tiere">Verbringungen von Tieren</mat-checkbox>
                            <mat-checkbox formControlName="einstreuFuttermittel"
                                >Verbringungen von Einstreu/Futtermitteln</mat-checkbox
                            >
                            <mat-checkbox formControlName="betreuungspersonal">Betreuungspersonal</mat-checkbox>
                            <mat-checkbox formControlName="betriebsfahrzeuge">Betriebsfahrzeuge</mat-checkbox>
                            <mat-checkbox formControlName="geraetschaften">Gemeinsam genutzte Gerätschaften</mat-checkbox>
                            <mat-checkbox formControlName="treibwege">Gemeinsam genutzte Treibwege</mat-checkbox>
                        </div>
                        <div class="inline-with-field">
                            <mat-checkbox formControlName="sonstige">Sonstige Verbindungen</mat-checkbox>
                            <mat-form-field appearance="outline">
                                <mat-label>Wenn ja, welche?</mat-label>
                                <input matInput formControlName="sonstigeText" />
                            </mat-form-field>
                        </div>
                    </div>
                </div>

                <div class="subsection bottom">
                    <div formGroupName="betriebsfremdeHaltungenWiederkaeuer500m">
                        <h4>Sind betriebsfremde Haltungen mit Wiederkäuern im Radius von 500 m bekannt?</h4>
                        <div class="radio-with-input">
                            <mat-radio-group formControlName="bekannt">
                                <mat-radio-button [value]="true">Ja</mat-radio-button>
                                <mat-radio-button [value]="false">Nein</mat-radio-button>
                            </mat-radio-group>
                            <mat-form-field appearance="outline">
                                <mat-label>Tierart</mat-label>
                                <input matInput formControlName="tierart" />
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="if-yes-block" formGroupName="infektionsquellenUmgebung">
                        <h4>Welche weiteren relevanten möglichen Infektionsquellen in der Umgebung gibt es?</h4>
                        <div class="checkbox-grid four-cols">
                            <mat-checkbox formControlName="schlachthof">Schlachthof</mat-checkbox>
                            <mat-checkbox formControlName="sammelstelle">Sammelstelle</mat-checkbox>
                            <mat-checkbox formControlName="rindertransportunternehmen">Rindertransportunternehmen</mat-checkbox>
                            <mat-checkbox formControlName="sonstige">Sonstige</mat-checkbox>
                        </div>
                        <mat-form-field appearance="outline" class="mt-8">
                            <mat-label>Sonstige Details</mat-label>
                            <input matInput formControlName="sonstigeText" />
                        </mat-form-field>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="card section-five" formGroupName="kenntnisseSensibilisierungUnterweisungen">
        <div class="section-title-with-info">
            <h3>2 Kenntnisse, Sensibilisierung, Unterweisungen</h3>
            <button
                mat-icon-button
                type="button"
                aria-label="Infos zu Kenntnisse, Sensibilisierung, Unterweisungen"
                (click)="openSection2Info(section2InfoDialog)"
            >
                <mat-icon>info</mat-icon>
            </button>
        </div>
        <p class="subline">
            Handlungsbedarf besteht, wenn rechtliche Anforderungen nicht erfüllt wurden oder aus fachlicher Sicht
            Maßnahmen umgesetzt werden sollten (gilt auch für alle folgenden Kapitel).
        </p>

        <div class="section-five-grid">
            <div class="subsection top" formGroupName="tierhalterUnternehmerPersonal">
                <h4>2.1 Tierhalter/Unternehmer/Personal</h4>
                <div class="handlungsbedarf-inline">
                    <span>Handlungsbedarf</span>
                    <mat-radio-group formControlName="handlungsbedarf">
                        <mat-radio-button [value]="true">Ja</mat-radio-button>
                        <mat-radio-button [value]="false">Nein</mat-radio-button>
                    </mat-radio-group>
                </div>

                <div class="stage-table">
                    <div class="stage-head stufe1">Stufe I</div>
                    <div class="stage-head stufe2">Stufe II</div>
                    <div class="stage-head stufe3">Stufe III</div>

                    <div class="stage-body two-col-span">
                        Kenntnisse zur Biosicherheit und Wissen über aktuelle Tierseuchengefahren sind vorhanden und werden
                        vermittelt.
                        <br /><br />
                        <strong>Klare Verantwortlichkeiten:</strong>
                        <ul>
                            <li>Kommunikationswege</li>
                            <li>Vertretungsregelungen</li>
                            <li>Regelungen für Aushilfspersonal</li>
                        </ul>
                    </div>
                    <div class="stage-body">
                        <strong>Empfehlung:</strong><br />
                        Grundschulung für neues Personal; mindestens alle 2 Jahre Fortbildung zur Auffrischung der
                        Sachkunde (auch im Rahmen von Tiergesundheitsbesuchen).<br />
                        Havarieplan und Kontaktliste für Notfälle.
                    </div>

                    <div class="stage-question two-col-span">
                        Wie werden Kenntnisse im Betrieb vermittelt und wo sind Verantwortlichkeiten festgelegt?
                    </div>
                    <div class="stage-question">Hinweis auf bestehende Dokumente</div>

                    <div class="stage-input two-col-span">
                        <mat-form-field appearance="outline">
                            <textarea matInput rows="3" formControlName="vermittlungKenntnisse"></textarea>
                        </mat-form-field>
                    </div>
                    <div class="stage-input">
                        <mat-form-field appearance="outline">
                            <input matInput formControlName="dokumentenhinweis" />
                        </mat-form-field>
                    </div>
                </div>
            </div>

            <div class="subsection top" formGroupName="drittePersonenBesucher">
                <h4>2.2 Tierarzt/Fachbesucher/Berater/Handwerker/Gäste</h4>

                <div class="handlungsbedarf-inline">
                    <span>Handlungsbedarf</span>
                    <mat-radio-group formControlName="handlungsbedarf">
                        <mat-radio-button [value]="true">Ja</mat-radio-button>
                        <mat-radio-button [value]="false">Nein</mat-radio-button>
                    </mat-radio-group>
                </div>

                <div class="stage-table">
                    <div class="stage-head stufe1">Stufe I</div>
                    <div class="stage-head stufe2">Stufe II</div>
                    <div class="stage-head stufe3">Stufe III</div>

                    <div class="stage-body two-col-span">
                        Grundsätzlich sollen bei der Reihenfolge planbarer Betriebsbesuche Betriebe mit höherem
                        Gesundheitsstatus bzw. höherer Sicherheitsstufe vorangestellt werden.
                        <br /><br />
                        Dazu muss der Tierhalter sein Risiko zuverlässig mitteilen können (siehe auch 4.4.5, 4.4.6, 4.4.7
                        und 4.4.8).
                    </div>
                    <div class="stage-body">
                        Betreten des Tierbereiches nur in Absprache mit dem Verantwortlichen.<br />
                        Besucher in Biosicherheitsvorgaben unterweisen.<br />
                        Einhaltung regelmäßig reflektieren.<br />
                        Besucherbuch führen.<br />
                        Unterweisungen dokumentieren.
                    </div>

                    <div class="stage-question two-col-span">
                        Wie wird sichergestellt, dass Dritte den Betrieb nur in Absprache mit dem Verantwortlichen betreten
                        und in Biosicherheit unterwiesen werden?
                    </div>
                    <div class="stage-question">Hinweis auf bestehende Dokumente</div>

                    <div class="stage-input two-col-span">
                        <mat-form-field appearance="outline">
                            <textarea matInput rows="3" formControlName="sicherstellungZutrittUnterweisung"></textarea>
                        </mat-form-field>
                    </div>
                    <div class="stage-input">
                        <mat-form-field appearance="outline">
                            <input matInput formControlName="dokumentenhinweis" />
                        </mat-form-field>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="card section-six" formGroupName="baulicheGegebenheiten">
        <div class="section-title-with-info section-six-header">
            <h3>3 Bauliche Gegebenheiten, Lageskizze</h3>
            <div class="section-actions">
                <button
                    mat-stroked-button
                    type="button"
                    aria-label="Lageplan-Legende anzeigen"
                    (click)="openLageplanLegende(lageplanLegendeDialog)"
                >
                    Legende
                </button>
                <button
                    mat-icon-button
                    type="button"
                    aria-label="Lageplan-Legende als Pop-out öffnen"
                    (click)="openLageplanLegendePopout()"
                >
                    <mat-icon>open_in_new</mat-icon>
                </button>
                <button
                    mat-icon-button
                    type="button"
                    aria-label="Infos zu Bauliche Gegebenheiten, Lageskizze"
                    (click)="openSection2Info(section3InfoDialog)"
                >
                    <mat-icon>info</mat-icon>
                </button>
            </div>
        </div>

        <div class="subsection top upload-card">
            <h4>Lageskizze / Dokumente hochladen</h4>
            <input #sketchUploader type="file" multiple hidden (change)="onSketchFilesSelected($event)" />
            <div class="upload-list" *ngIf="sketchUploads.length > 0">
                <div class="upload-list-row" *ngFor="let entry of sketchUploads; let i = index">
                    <div class="upload-list-item-button">
                        <button type="button" class="upload-file-link" (click)="openSketch(entry, sketchPreviewDialog)">
                            <mat-icon>description</mat-icon>
                            <span>{{ entry.dateiname }}</span>
                        </button>
                        <button
                            *ngIf="!isReadOnly()"
                            mat-icon-button
                            type="button"
                            aria-label="Datei löschen"
                            class="upload-delete-btn"
                            (click)="removeSketch(i)"
                        >
                            <mat-icon>delete</mat-icon>
                        </button>
                    </div>
                    <div class="upload-list-empty"></div>
                </div>
            </div>
            <button
                *ngIf="!isReadOnly()"
                type="button"
                class="upload-dropzone"
                (click)="openSketchFilePicker(sketchUploader)"
                (dragover)="onSketchDragOver($event)"
                (drop)="onSketchDrop($event)"
            >
                <mat-icon>upload_file</mat-icon>
                <div class="upload-title">Dateien hier reinziehen oder klicken</div>
                <div class="upload-subtitle">z. B. Lageskizze, Fotos, PDF, Dokumente</div>
            </button>
        </div>

        <div class="section-six-grid">
        <div class="subsection top" formGroupName="hofzugaengeHinweisschilder">
            <h4>3.1 Hofzugänge und Hinweisschilder</h4>
            <div class="handlungsbedarf-inline">
                <span>Handlungsbedarf</span>
                <mat-radio-group formControlName="handlungsbedarf">
                    <mat-radio-button [value]="true">Ja</mat-radio-button>
                    <mat-radio-button [value]="false">Nein</mat-radio-button>
                </mat-radio-group>
            </div>
            <div class="stage-table">
                <div class="stage-head stufe1">Stufe I</div>
                <div class="stage-head stufe2">Stufe II</div>
                <div class="stage-head stufe3">Stufe III</div>
                <div class="stage-body">
                    Auf das Verbot des unbefugten Betretens weist ein Hinweisschild hin.
                    <br />z. B. "Wertvoller Rinderbestand - Betreten oder Befahren des Betriebes für Unbefugte verboten!"
                    <br />PKW-Parkplätze für Dritte ausweisen.
                </div>
                <div class="stage-body">
                    Ein zusätzliches Tor an der Hofeinfahrt, das bei Bedarf geschlossen werden kann, ermöglicht es,
                    unbefugte Personen kurzfristig am Betreten des Betriebsgeländes zu hindern.
                </div>
                <div class="stage-body">
                    Ein verschlossenes Tor an der Hofeinfahrt ermöglicht die Beschränkung des Zutritts auf befugte Personen.
                    Zusätzliche Hinweisschilder an Seiten der Einfriedung mit öffentlichen Wegen anbringen.
                    Beschilderung an allen Eingängen und Toren.
                </div>
                <div class="stage-question two-col-span">Umsetzung siehe Lageskizze.</div>
                <div class="stage-question">Hinweis auf bestehende Dokumente</div>
                <div class="stage-input two-col-span">
                    <mat-form-field appearance="outline">
                        <textarea matInput rows="2" formControlName="umsetzung"></textarea>
                    </mat-form-field>
                </div>
                <div class="stage-input">
                    <mat-form-field appearance="outline">
                        <input matInput formControlName="dokumentenhinweis" />
                    </mat-form-field>
                </div>
            </div>
        </div>

        <div class="subsection" formGroupName="bewegungBetriebsgelaende">
            <h4>3.2 Bewegung auf dem Betriebsgelände</h4>
            <div class="handlungsbedarf-inline">
                <span>Handlungsbedarf</span>
                <mat-radio-group formControlName="handlungsbedarf">
                    <mat-radio-button [value]="true">Ja</mat-radio-button>
                    <mat-radio-button [value]="false">Nein</mat-radio-button>
                </mat-radio-group>
            </div>
            <div class="stage-table">
                <div class="stage-head stufe1">Stufe I</div>
                <div class="stage-head stufe2">Stufe II</div>
                <div class="stage-head stufe3">Stufe III</div>
                <div class="stage-body two-col-span">
                    Kurze, direkte Wege zum Stall- und Futterlagerbereich ohne Kreuzung kontaminierter Wege mindern die
                    Gefahr der Übertragung von Krankheitserregern durch Personen und Fahrzeuge.
                </div>
                <div class="stage-body">
                    Die Zuwegung für betriebsfremde Fahrzeuge und Personen muss ohne Kreuzung kontaminierter Wege und
                    Flächen gewährleistet werden.
                </div>
                <div class="stage-question two-col-span">
                    Wie wird sichergestellt, dass sich Wege möglichst nicht kreuzen und Kontaminationen vermieden werden?
                </div>
                <div class="stage-question">Hinweis auf bestehende Dokumente</div>
                <div class="stage-input two-col-span">
                    <mat-form-field appearance="outline">
                        <textarea matInput rows="2" formControlName="umsetzung"></textarea>
                    </mat-form-field>
                </div>
                <div class="stage-input">
                    <mat-form-field appearance="outline">
                        <input matInput formControlName="dokumentenhinweis" />
                    </mat-form-field>
                </div>
            </div>
        </div>

        <div class="subsection" formGroupName="milchuebergabestelle">
            <h4>3.3 Gestaltung der Milchübergabestelle</h4>
            <div class="handlungsbedarf-inline">
                <span>Handlungsbedarf</span>
                <mat-radio-group formControlName="handlungsbedarf">
                    <mat-radio-button [value]="true">Ja</mat-radio-button>
                    <mat-radio-button [value]="false">Nein</mat-radio-button>
                </mat-radio-group>
            </div>
            <div class="stage-table">
                <div class="stage-head stufe1">Stufe I</div>
                <div class="stage-head stufe2">Stufe II</div>
                <div class="stage-head stufe3">Stufe III</div>
                <div class="stage-body two-col-span">
                    Die Milch-Übergabestelle muss planbefestigt und leicht zu reinigen sein. Ein direkter Zugang von außen
                    (nicht durch den Stall) ist gewährleistet.
                </div>
                <div class="stage-body">
                    Die Milchkammer verfügt über Handwaschmöglichkeiten. Sie ist leicht zu reinigen und zu desinfizieren.
                </div>
                <div class="stage-question two-col-span">Wie ist die Milch-Übergabestelle gestaltet?</div>
                <div class="stage-question">Hinweis auf bestehende Dokumente</div>
                <div class="stage-input two-col-span">
                    <mat-form-field appearance="outline">
                        <textarea matInput rows="2" formControlName="umsetzung"></textarea>
                    </mat-form-field>
                </div>
                <div class="stage-input">
                    <mat-form-field appearance="outline">
                        <input matInput formControlName="dokumentenhinweis" />
                    </mat-form-field>
                </div>
            </div>
        </div>

        <div class="subsection" formGroupName="funktionsbereichstrennung">
            <h4>3.4 Funktionsbereichstrennung</h4>
            <div class="handlungsbedarf-inline">
                <span>Handlungsbedarf</span>
                <mat-radio-group formControlName="handlungsbedarf">
                    <mat-radio-button [value]="true">Ja</mat-radio-button>
                    <mat-radio-button [value]="false">Nein</mat-radio-button>
                </mat-radio-group>
            </div>
            <div class="stage-table">
                <div class="stage-head stufe1">Stufe I</div>
                <div class="stage-head stufe2">Stufe II</div>
                <div class="stage-head stufe3">Stufe III</div>
                <div class="stage-body two-col-span">
                    Lagerbereiche von Flüssig- oder Festmist sind von Fütterungseinrichtungen, einschließlich Futtertisch,
                    in geeigneter Weise baulich abzutrennen.
                </div>
                <div class="stage-body">
                    An Übergängen von Laufflächen auf dem Futtertisch sollten Möglichkeiten zur Reinigung des Schuhwerks
                    vorhanden sein.
                </div>
                <div class="stage-question two-col-span">Wie wird die Funktionsbereichstrennung sichergestellt?</div>
                <div class="stage-question">Hinweis auf bestehende Dokumente</div>
                <div class="stage-input two-col-span">
                    <mat-form-field appearance="outline">
                        <textarea matInput rows="2" formControlName="umsetzung"></textarea>
                    </mat-form-field>
                </div>
                <div class="stage-input">
                    <mat-form-field appearance="outline">
                        <input matInput formControlName="dokumentenhinweis" />
                    </mat-form-field>
                </div>
            </div>
        </div>

        <div class="subsection" formGroupName="trennungTierarten">
            <h4>3.5 Trennung unterschiedlicher Tierarten</h4>
            <div class="handlungsbedarf-inline">
                <span>Handlungsbedarf</span>
                <mat-radio-group formControlName="handlungsbedarf">
                    <mat-radio-button [value]="true">Ja</mat-radio-button>
                    <mat-radio-button [value]="false">Nein</mat-radio-button>
                </mat-radio-group>
            </div>
            <div class="stage-table">
                <div class="stage-head stufe1">Stufe I</div>
                <div class="stage-head stufe2">Stufe II</div>
                <div class="stage-head stufe3">Stufe III</div>
                <div class="stage-body">
                    Unterschiedliche Tierarten sollten vollständig räumlich getrennt gehalten werden.
                </div>
                <div class="stage-body">
                    Unterschiedliche Tierarten sind vollständig räumlich getrennt zu halten.
                    <br />Tierbereiche sind von Ver- und Entsorgungsbereichen räumlich zu trennen.
                </div>
                <div class="stage-body">
                    Risikoabschätzung zum Eintrag von Krankheitserregern durch Wild- und Haustiere durchführen.
                    <br />Wild- und Haustiere von Stall und Lagern fernhalten (Abdeckung von Futter und Einstreu).
                </div>
                <div class="stage-question two-col-span">Wie wird die physische Trennung umgesetzt/verbessert?</div>
                <div class="stage-question">Hinweis auf bestehende Dokumente</div>
                <div class="stage-input two-col-span">
                    <mat-form-field appearance="outline">
                        <textarea matInput rows="2" formControlName="umsetzung"></textarea>
                    </mat-form-field>
                </div>
                <div class="stage-input">
                    <mat-form-field appearance="outline">
                        <input matInput formControlName="dokumentenhinweis" />
                    </mat-form-field>
                </div>
            </div>
        </div>

        <div class="subsection" formGroupName="krankenbuchten">
            <h4>3.6 Krankenbuchten</h4>
            <div class="handlungsbedarf-inline">
                <span>Handlungsbedarf</span>
                <mat-radio-group formControlName="handlungsbedarf">
                    <mat-radio-button [value]="true">Ja</mat-radio-button>
                    <mat-radio-button [value]="false">Nein</mat-radio-button>
                </mat-radio-group>
            </div>
            <div class="stage-table">
                <div class="stage-head stufe1">Stufe I</div>
                <div class="stage-head stufe2">Stufe II</div>
                <div class="stage-head stufe3">Stufe III</div>
                <div class="stage-body three-col-span">
                    Durch Absonderung von Tieren in einem Krankenabteil/Krankenstall wird die Übertragung von
                    Krankheitserregern auf den übrigen Tierbestand vermieden. Das Krankenabteil sollte möglichst so
                    gelegen sein, dass Kreuzkontaminationen z. B. auf dem Weg zum Melkstand vermieden werden.
                    <br /><strong>Hinweis:</strong> Krankenbuchten gelten nicht als Abkalbebuchten.
                </div>
                <div class="stage-question two-col-span">Wie wird die Kreuzkontamination vermieden?</div>
                <div class="stage-question">Hinweis auf bestehende Dokumente</div>
                <div class="stage-input two-col-span">
                    <mat-form-field appearance="outline">
                        <textarea matInput rows="2" formControlName="umsetzung"></textarea>
                    </mat-form-field>
                </div>
                <div class="stage-input">
                    <mat-form-field appearance="outline">
                        <input matInput formControlName="dokumentenhinweis" />
                    </mat-form-field>
                </div>
            </div>
        </div>

        <div class="subsection abkalbebereich-section" formGroupName="abkalbebereich">
            <h4>3.7 Abkalbebereich</h4>
            <div class="handlungsbedarf-inline">
                <span>Handlungsbedarf</span>
                <mat-radio-group formControlName="handlungsbedarf">
                    <mat-radio-button [value]="true">Ja</mat-radio-button>
                    <mat-radio-button [value]="false">Nein</mat-radio-button>
                </mat-radio-group>
            </div>
            <div class="stage-table">
                <div class="stage-head stufe1">Stufe I</div>
                <div class="stage-head stufe2">Stufe II</div>
                <div class="stage-head stufe3">Stufe III</div>
                <div class="stage-body three-col-span">
                    Neben Krankenbuchten benötigen Milchvieh- und Mutterkuhbetriebe einen getrennten Abkalbebereich, je nach
                    Betriebsgröße mit mehreren Abteilen.
                </div>
                <div class="stage-question two-col-span">Wo befinden sich die Abkalbebereiche? Umsetzung siehe Lageskizze.</div>
                <div class="stage-question">Hinweis auf bestehende Dokumente</div>
                <div class="stage-input two-col-span">
                    <mat-form-field appearance="outline">
                        <textarea matInput rows="2" formControlName="umsetzung"></textarea>
                    </mat-form-field>
                </div>
                <div class="stage-input">
                    <mat-form-field appearance="outline">
                        <input matInput formControlName="dokumentenhinweis" />
                    </mat-form-field>
                </div>
            </div>
        </div>
        </div>
    </section>

    <section class="card section-seven" formGroupName="personenUndFahrzeugverkehr">
        <div class="section-title-with-info">
            <h3>4 Personen und Fahrzeugverkehr</h3>
            <button
                mat-icon-button
                type="button"
                aria-label="Infos zu Personen und Fahrzeugverkehr"
                (click)="openSection2Info(section4InfoDialog)"
            >
                <mat-icon>info</mat-icon>
            </button>
        </div>

        <div class="section-seven-grid">
            <div class="subsection top" formGroupName="kontaminierteFahrzeuge">
                <h4>4.1 Kontaminierte Fahrzeuge</h4>
                <div class="handlungsbedarf-inline"><span>Handlungsbedarf</span><mat-radio-group formControlName="handlungsbedarf"><mat-radio-button [value]="true">Ja</mat-radio-button><mat-radio-button [value]="false">Nein</mat-radio-button></mat-radio-group></div>
                <div class="stage-table">
                    <div class="stage-head stufe1">Stufe I</div><div class="stage-head stufe2">Stufe II</div><div class="stage-head stufe3">Stufe III</div>
                    <div class="stage-body">Auf Sauberkeit der Fahrzeuge ist zu achten, weil dadurch die Wahrscheinlichkeit einer Kontamination mit Erregern reduziert ist.</div>
                    <div class="stage-body">Die Notwendigkeit des Befahrens ist im Einzelfall zu hinterfragen. Die Beschränkung des Fahrzeugverkehrs vermindert mögliche Verschleppungen.</div>
                    <div class="stage-body">Erregerverschleppung durch unvermeidbaren Fahrzeugverkehr durch Reinigung/Desinfektion in Schleusen an der Hofeinfahrt minimieren.</div>
                    <div class="stage-body three-col-span">Im Seuchenfall (insb. MKS) Zuwegung für Milchsammelwagen nur über befestigte, nicht gekreuzte Wege; geeignete Desinfektionsmittel an Zu- und Abfahrten gewährleisten.</div>
                    <div class="stage-question two-col-span">Wie wird sichergestellt, dass die Fahrzeuge in einem sauberen Zustand sind?</div><div class="stage-question">Hinweis auf bestehende Dokumente</div>
                    <div class="stage-input two-col-span"><mat-form-field appearance="outline"><textarea matInput rows="2" formControlName="umsetzung"></textarea></mat-form-field></div>
                    <div class="stage-input"><mat-form-field appearance="outline"><input matInput formControlName="dokumentenhinweis" /></mat-form-field></div>
                </div>
            </div>

            <div class="subsection top" formGroupName="kreuzkontamination">
                <h4>4.2 Kreuzkontamination</h4>
                <div class="handlungsbedarf-inline"><span>Handlungsbedarf</span><mat-radio-group formControlName="handlungsbedarf"><mat-radio-button [value]="true">Ja</mat-radio-button><mat-radio-button [value]="false">Nein</mat-radio-button></mat-radio-group></div>
                <div class="stage-table">
                    <div class="stage-head stufe1">Stufe I</div><div class="stage-head stufe2">Stufe II</div><div class="stage-head stufe3">Stufe III</div>
                    <div class="stage-body">Kurze und direkte Wege vermindern die Gefahr der betriebsinternen Erregerverschleppung.</div>
                    <div class="stage-body">Verschleppungen durch Personen von Bereichen hoher zu geringer Erregerdichte vermeiden.</div>
                    <div class="stage-body">Unkontrollierte Personen- und Fahrzeugbewegungen ausschließen; Kontaminationsquellen analysieren und Wege klar festlegen.</div>
                    <div class="stage-question two-col-span">Wie wird vermieden, dass Erreger verschleppt werden?</div><div class="stage-question">Hinweis auf bestehende Dokumente</div>
                    <div class="stage-input two-col-span"><mat-form-field appearance="outline"><textarea matInput rows="2" formControlName="umsetzung"></textarea></mat-form-field></div>
                    <div class="stage-input"><mat-form-field appearance="outline"><input matInput formControlName="dokumentenhinweis" /></mat-form-field></div>
                </div>
            </div>

            <div class="subsection" formGroupName="innerbetrieblicheTiertransportFahrzeuge">
                <h4>4.3 Innerbetriebliche Tiertransport-Fahrzeuge</h4>
                <div class="handlungsbedarf-inline"><span>Handlungsbedarf</span><mat-radio-group formControlName="handlungsbedarf"><mat-radio-button [value]="true">Ja</mat-radio-button><mat-radio-button [value]="false">Nein</mat-radio-button></mat-radio-group></div>
                <div class="stage-table">
                    <div class="stage-head stufe1">Stufe I</div><div class="stage-head stufe2">Stufe II</div><div class="stage-head stufe3">Stufe III</div>
                    <div class="stage-body">Innerbetriebliche Tiertransporte möglichst ausschließlich in gereinigten Fahrzeugen.</div>
                    <div class="stage-body">Betriebseigene Fahrzeuge bevorzugen; Bauweise muss für wirksame Reinigung/Desinfektion geeignet sein.</div>
                    <div class="stage-body">Ausschließlich betriebseigene, gereinigte Fahrzeuge nutzen; bei betriebsstättenübergreifender Nutzung Desinfektion durchführen.</div>
                    <div class="stage-question two-col-span">Mit welchen Fahrzeugen erfolgt der innerbetriebliche Tiertransport und wie wird deren Sauberkeit sichergestellt?</div><div class="stage-question">Hinweis auf bestehende Dokumente</div>
                    <div class="stage-input two-col-span"><mat-form-field appearance="outline"><textarea matInput rows="2" formControlName="umsetzung"></textarea></mat-form-field></div>
                    <div class="stage-input"><mat-form-field appearance="outline"><input matInput formControlName="dokumentenhinweis" /></mat-form-field></div>
                </div>
            </div>

            <div class="subsection" formGroupName="geraetschaften">
                <h4>4.4 Gerätschaften</h4>
                <div class="handlungsbedarf-inline"><span>Handlungsbedarf</span><mat-radio-group formControlName="handlungsbedarf"><mat-radio-button [value]="true">Ja</mat-radio-button><mat-radio-button [value]="false">Nein</mat-radio-button></mat-radio-group></div>
                <div class="stage-table">
                    <div class="stage-head stufe1">Stufe I</div><div class="stage-head stufe2">Stufe II</div><div class="stage-head stufe3">Stufe III</div>
                    <div class="stage-body">Gerätschaften sollten sauber und gereinigt sein, um Erregerübertragung vorzubeugen.</div>
                    <div class="stage-body">Bauweise muss für wirksame Reinigung und Desinfektion geeignet sein.</div>
                    <div class="stage-body">Ausschließlich betriebsstätteneigene, gereinigte Geräte verwenden; regelmäßige Gerätedesinfektion durchführen.</div>
                    <div class="stage-question two-col-span">Wie ist der Umgang mit Gerätschaften?</div><div class="stage-question">Hinweis auf bestehende Dokumente</div>
                    <div class="stage-input two-col-span"><mat-form-field appearance="outline"><textarea matInput rows="2" formControlName="umsetzung"></textarea></mat-form-field></div>
                    <div class="stage-input"><mat-form-field appearance="outline"><input matInput formControlName="dokumentenhinweis" /></mat-form-field></div>
                </div>
            </div>

            <div class="subsection" formGroupName="zutrittVonPersonen">
                <h4>4.5 Zutritt von Personen</h4>
                <div class="handlungsbedarf-inline"><span>Handlungsbedarf</span><mat-radio-group formControlName="handlungsbedarf"><mat-radio-button [value]="true">Ja</mat-radio-button><mat-radio-button [value]="false">Nein</mat-radio-button></mat-radio-group></div>
                <div class="stage-table">
                    <div class="stage-head stufe1">Stufe I</div><div class="stage-head stufe2">Stufe II</div><div class="stage-head stufe3">Stufe III</div>
                    <div class="stage-body">Betreten des Stalles auf autorisierte Personen beschränken.</div>
                    <div class="stage-body">Stallzutritt nur in Absprache/Begleitung von Betriebspersonal; Hygieneregeln überwachen.</div>
                    <div class="stage-body">Notwendigkeit des Stallzutritts kritisch prüfen; nur unerlässliche Personen in Begleitung zulassen; Besucherbuch und Dokumentation.</div>
                    <div class="stage-question two-col-span">Wie wird gewährleistet, dass nur befugte Personen den Stall betreten?</div><div class="stage-question">Hinweis auf bestehende Dokumente</div>
                    <div class="stage-input two-col-span"><mat-form-field appearance="outline"><textarea matInput rows="2" formControlName="umsetzung"></textarea></mat-form-field></div>
                    <div class="stage-input"><mat-form-field appearance="outline"><input matInput formControlName="dokumentenhinweis" /></mat-form-field></div>
                </div>
            </div>

            <div class="subsection" formGroupName="potentiellKontaminiertePersonen">
                <h4>4.6 Potentiell kontaminierte Personen</h4>
                <div class="handlungsbedarf-inline"><span>Handlungsbedarf</span><mat-radio-group formControlName="handlungsbedarf"><mat-radio-button [value]="true">Ja</mat-radio-button><mat-radio-button [value]="false">Nein</mat-radio-button></mat-radio-group></div>
                <div class="stage-table">
                    <div class="stage-head stufe1">Stufe I</div><div class="stage-head stufe2">Stufe II</div><div class="stage-head stufe3">Stufe III</div>
                    <div class="stage-body">Umkleidemöglichkeit stallnah vorhalten; Einweg-/Schutzkleidung für betriebsfremde Personen.</div>
                    <div class="stage-body">Umkleidemöglichkeit am Eingang zum Tierbereich; Schuhreinigung/-desinfektion und regelmäßige Kontrolle.</div>
                    <div class="stage-body">Konsequente Nutzung, Reinigung und Desinfektion; vollständiger Kleidungswechsel mit Schleusenkonzept idealerweise mit Dusche.</div>
                    <div class="stage-question two-col-span">Ist eine Umkleidemöglichkeit vorhanden und wird diese konsequent genutzt?</div><div class="stage-question">Hinweis auf bestehende Dokumente</div>
                    <div class="stage-input two-col-span"><mat-form-field appearance="outline"><textarea matInput rows="2" formControlName="umsetzung"></textarea></mat-form-field></div>
                    <div class="stage-input"><mat-form-field appearance="outline"><input matInput formControlName="dokumentenhinweis" /></mat-form-field></div>
                </div>
            </div>

            <div class="subsection" formGroupName="verschleppungVonInfektionen">
                <h4>4.7 Verschleppung von Infektionen</h4>
                <div class="handlungsbedarf-inline"><span>Handlungsbedarf</span><mat-radio-group formControlName="handlungsbedarf"><mat-radio-button [value]="true">Ja</mat-radio-button><mat-radio-button [value]="false">Nein</mat-radio-button></mat-radio-group></div>
                <div class="stage-table">
                    <div class="stage-head stufe1">Stufe I</div><div class="stage-head stufe2">Stufe II</div><div class="stage-head stufe3">Stufe III</div>
                    <div class="stage-body">Stiefelreinigung am Hauptzugang; Handwaschbecken mit warmem Wasser, Seife und Handtuch.</div>
                    <div class="stage-body">Desinfektionsmöglichkeit für gereinigte Stiefel, Hände und Instrumentarium; Einmalhandtücher verwenden.</div>
                    <div class="stage-body">Betreuungsreihenfolge von Jung nach Alt festlegen und einhalten.</div>
                    <div class="stage-question two-col-span">Welche Reinigungs- und Desinfektionsmöglichkeiten werden vorgehalten und routinemäßig angewendet?</div><div class="stage-question">Hinweis auf bestehende Dokumente</div>
                    <div class="stage-input two-col-span"><mat-form-field appearance="outline"><textarea matInput rows="2" formControlName="umsetzung"></textarea></mat-form-field></div>
                    <div class="stage-input"><mat-form-field appearance="outline"><input matInput formControlName="dokumentenhinweis" /></mat-form-field></div>
                </div>
            </div>

            <div class="subsection" formGroupName="betriebsfremdePersonen">
                <h4>4.8 Betriebsfremde Personen</h4>
                <div class="handlungsbedarf-inline"><span>Handlungsbedarf</span><mat-radio-group formControlName="handlungsbedarf"><mat-radio-button [value]="true">Ja</mat-radio-button><mat-radio-button [value]="false">Nein</mat-radio-button></mat-radio-group></div>
                <div class="stage-table">
                    <div class="stage-head stufe1">Stufe I</div><div class="stage-head stufe2">Stufe II</div><div class="stage-head stufe3">Stufe III</div>
                    <div class="stage-body two-col-span">Separation und Fixation vorzustellender Einzeltiere verkürzt Wege und verringert unnötige Tierkontakte.</div>
                    <div class="stage-body">Räumlich vollständige Separation umgeht Kontakt betriebsfremder Personen mit der Herde.</div>
                    <div class="stage-question two-col-span">Wie können vorzustellende Tiere für betriebsfremde Personen separiert und fixiert werden?</div><div class="stage-question">Hinweis auf bestehende Dokumente</div>
                    <div class="stage-input two-col-span"><mat-form-field appearance="outline"><textarea matInput rows="2" formControlName="umsetzung"></textarea></mat-form-field></div>
                    <div class="stage-input"><mat-form-field appearance="outline"><input matInput formControlName="dokumentenhinweis" /></mat-form-field></div>
                </div>
            </div>

            <div class="subsection" formGroupName="besuchergruppen">
                <h4>4.9 Besuchergruppen</h4>
                <div class="handlungsbedarf-inline"><span>Handlungsbedarf</span><mat-radio-group formControlName="handlungsbedarf"><mat-radio-button [value]="true">Ja</mat-radio-button><mat-radio-button [value]="false">Nein</mat-radio-button></mat-radio-group></div>
                <div class="stage-table">
                    <div class="stage-head stufe1">Stufe I</div><div class="stage-head stufe2">Stufe II</div><div class="stage-head stufe3">Stufe III</div>
                    <div class="stage-body">Beim Betreten des Futtertisches vermeiden, durch das Futter zu laufen.</div>
                    <div class="stage-body">Überschuhe/Füßlinge oder saubere Stiefel nutzen; nach Besuch reinigen.</div>
                    <div class="stage-body">Einweg-/Schutzkleidung vorhalten; Besuchergang oder vollständiger Kleidungswechsel mit Schleuse nutzen.</div>
                    <div class="stage-question two-col-span">Wie wird das Eintragsrisiko durch Besuchergruppen gesenkt?</div><div class="stage-question">Hinweis auf bestehende Dokumente</div>
                    <div class="stage-input two-col-span"><mat-form-field appearance="outline"><textarea matInput rows="2" formControlName="umsetzung"></textarea></mat-form-field></div>
                    <div class="stage-input"><mat-form-field appearance="outline"><input matInput formControlName="dokumentenhinweis" /></mat-form-field></div>
                </div>
            </div>

            <div class="subsection" formGroupName="instrumentarium">
                <h4>4.10 Instrumentarium</h4>
                <div class="handlungsbedarf-inline"><span>Handlungsbedarf</span><mat-radio-group formControlName="handlungsbedarf"><mat-radio-button [value]="true">Ja</mat-radio-button><mat-radio-button [value]="false">Nein</mat-radio-button></mat-radio-group></div>
                <div class="stage-table">
                    <div class="stage-head stufe1">Stufe I</div><div class="stage-head stufe2">Stufe II</div><div class="stage-head stufe3">Stufe III</div>
                    <div class="stage-body two-col-span">Reinigung und Desinfektion von Instrumentarium vor Wiedergebrauch; Einwegmaterialien minimieren Erregerverschleppung.</div>
                    <div class="stage-body">Wenn möglich getrennte Geräte und Arbeitsmaterialien je Nutzungsbereich vorhalten; betriebseigenes Instrumentarium bevorzugen.</div>
                    <div class="stage-question two-col-span">Wie ist der Umgang mit Instrumentarium?</div><div class="stage-question">Hinweis auf bestehende Dokumente</div>
                    <div class="stage-input two-col-span"><mat-form-field appearance="outline"><textarea matInput rows="2" formControlName="umsetzung"></textarea></mat-form-field></div>
                    <div class="stage-input"><mat-form-field appearance="outline"><input matInput formControlName="dokumentenhinweis" /></mat-form-field></div>
                </div>
            </div>
        </div>
    </section>

    <section class="card section-eight" formGroupName="tierverkehr">
        <div class="section-title-with-info">
            <h3>5 Tierverkehr</h3>
            <button mat-icon-button type="button" aria-label="Infos zu Tierverkehr" (click)="openSection2Info(section5InfoDialog)">
                <mat-icon>info</mat-icon>
            </button>
        </div>

        <div class="section-eight-grid">
            <div class="subsection top" formGroupName="versatzEinzeltiere">
                <h4>5.1 Versatz von Einzeltieren</h4>
                <div class="handlungsbedarf-inline"><span>Handlungsbedarf</span><mat-radio-group formControlName="handlungsbedarf"><mat-radio-button [value]="true">Ja</mat-radio-button><mat-radio-button [value]="false">Nein</mat-radio-button></mat-radio-group></div>
                <div class="stage-table">
                    <div class="stage-head stufe1">Stufe I</div><div class="stage-head stufe2">Stufe II</div><div class="stage-head stufe3">Stufe III</div>
                    <div class="stage-body two-col-span">Tiere mit Anzeichen infektiöser Erkrankung nicht zu gesunden Tieren versetzen; Umgruppierungen auch bei gesunden Tieren auf das notwendige Maß reduzieren.</div>
                    <div class="stage-body">Isoliermöglichkeit minimiert die Verbreitung von Krankheitserregern im gesamten Betrieb.</div>
                    <div class="stage-body three-col-span">Beim Übertrieb über Futtertisch anschließend reinigen und desinfizieren; Futtertische, Krippen und Tränken regelmäßig reinigen.</div>
                    <div class="stage-question two-col-span">Wie erfolgt der Versatz von Tieren mit Blick auf die Reduktion von Krankheitsübertragung?</div><div class="stage-question">Hinweis auf bestehende Dokumente</div>
                    <div class="stage-input two-col-span"><mat-form-field appearance="outline"><textarea matInput rows="2" formControlName="umsetzung"></textarea></mat-form-field></div>
                    <div class="stage-input"><mat-form-field appearance="outline"><input matInput formControlName="dokumentenhinweis" /></mat-form-field></div>
                </div>
            </div>

            <div class="subsection top" formGroupName="falltiere">
                <h4>5.2 Falltiere</h4>
                <div class="handlungsbedarf-inline"><span>Handlungsbedarf</span><mat-radio-group formControlName="handlungsbedarf"><mat-radio-button [value]="true">Ja</mat-radio-button><mat-radio-button [value]="false">Nein</mat-radio-button></mat-radio-group></div>
                <div class="stage-table">
                    <div class="stage-head stufe1">Stufe I</div><div class="stage-head stufe2">Stufe II</div><div class="stage-head stufe3">Stufe III</div>
                    <div class="stage-body three-col-span">Tote Tiere bis zur Abholung geschützt und getrennt lagern; nach Abholung Lagerplatz/Behältnis unverzüglich reinigen und desinfizieren.</div>
                    <div class="stage-body">Tägliche Bestandskontrolle und Entfernung toter Tiere; separater, möglichst befestigter Lagerplatz mit Abdeckung nahe Betriebsgrenze.</div>
                    <div class="stage-body two-col-span">Befestigte Platte mit Auffangmöglichkeit und Reinigungsoption; verschließbare Behältnisse/Gebäude verhindern Kontakt von Unbefugten/Wildtieren.</div>
                    <div class="stage-question two-col-span">Wie erfolgt die Lagerung von Falltieren?</div><div class="stage-question">Hinweis auf bestehende Dokumente</div>
                    <div class="stage-input two-col-span"><mat-form-field appearance="outline"><textarea matInput rows="2" formControlName="umsetzung"></textarea></mat-form-field></div>
                    <div class="stage-input"><mat-form-field appearance="outline"><input matInput formControlName="dokumentenhinweis" /></mat-form-field></div>
                </div>
            </div>

            <div class="subsection" formGroupName="ungewollteTierkontakte">
                <h4>5.3 Ungewollte Tierkontakte</h4>
                <div class="handlungsbedarf-inline"><span>Handlungsbedarf</span><mat-radio-group formControlName="handlungsbedarf"><mat-radio-button [value]="true">Ja</mat-radio-button><mat-radio-button [value]="false">Nein</mat-radio-button></mat-radio-group></div>
                <div class="stage-table">
                    <div class="stage-head stufe1">Stufe I</div><div class="stage-head stufe2">Stufe II</div><div class="stage-head stufe3">Stufe III</div>
                    <div class="stage-body three-col-span">Stallungen und Weiden so einrichten, dass keine Tiere entweichen können und ungewollte Tierkontakte (fremde Nutztiere/Wildtiere) vermieden werden.</div>
                    <div class="stage-question two-col-span">Für welche ungewollten Tierkontakte besteht ein Risiko und welche Maßnahmen werden ergriffen?</div><div class="stage-question">Hinweis auf bestehende Dokumente</div>
                    <div class="stage-input two-col-span"><mat-form-field appearance="outline"><textarea matInput rows="2" formControlName="umsetzung"></textarea></mat-form-field></div>
                    <div class="stage-input"><mat-form-field appearance="outline"><input matInput formControlName="dokumentenhinweis" /></mat-form-field></div>
                </div>
            </div>

            <div class="subsection" formGroupName="treibewegePensionshaltungBetriebsgrenzen">
                <h4>5.4 Treibewege/Pensionshaltung/Betriebsgrenzen</h4>
                <div class="handlungsbedarf-inline"><span>Handlungsbedarf</span><mat-radio-group formControlName="handlungsbedarf"><mat-radio-button [value]="true">Ja</mat-radio-button><mat-radio-button [value]="false">Nein</mat-radio-button></mat-radio-group></div>
                <div class="stage-table">
                    <div class="stage-head stufe1">Stufe I</div><div class="stage-head stufe2">Stufe II</div><div class="stage-head stufe3">Stufe III</div>
                    <div class="stage-body two-col-span">Gemeinschaftliche Weidehaltung/betriebsübergreifende Nutzung nur bei einheitlichem Gesundheitsstatus; unbeabsichtigten Tierkontakt durch sichere Einzäunung minimieren.</div>
                    <div class="stage-body">Unmittelbaren Kontakt unterschiedlicher Gesundheitsstatus unterbinden; erforderlichenfalls Doppelzaun.</div>
                    <div class="stage-body">Betriebsübergreifende Nutzung von Treibewegen und Weiden möglichst vermeiden.</div>
                    <div class="stage-body">Betriebsübergreifende Nutzung von Treibewegen und Weiden ausschließen.</div>
                    <div class="stage-question two-col-span">Wie wird sichergestellt, dass nur Tiere mit einheitlichem Gesundheitsstatus in Kontakt kommen?</div><div class="stage-question">Hinweis auf bestehende Dokumente</div>
                    <div class="stage-input two-col-span"><mat-form-field appearance="outline"><textarea matInput rows="2" formControlName="umsetzung"></textarea></mat-form-field></div>
                    <div class="stage-input"><mat-form-field appearance="outline"><input matInput formControlName="dokumentenhinweis" /></mat-form-field></div>
                </div>
            </div>

            <div class="subsection" formGroupName="tierverkehrZwischenBetrieben">
                <h4>5.5 Tierverkehr zwischen den Betrieben</h4>
                <div class="handlungsbedarf-inline"><span>Handlungsbedarf</span><mat-radio-group formControlName="handlungsbedarf"><mat-radio-button [value]="true">Ja</mat-radio-button><mat-radio-button [value]="false">Nein</mat-radio-button></mat-radio-group></div>
                <div class="stage-table">
                    <div class="stage-head stufe1">Stufe I</div><div class="stage-head stufe2">Stufe II</div><div class="stage-head stufe3">Stufe III</div>
                    <div class="stage-body">Nur klinisch gesunde Tiere aufnehmen.</div>
                    <div class="stage-body">Aufgenommene Tiere sollen gleichen oder höheren Gesundheitsstatus haben; Konzept zur Risikominimierung bei Zugängen vorhanden.</div>
                    <div class="stage-body">Zusätzliche Untersuchungen und Quarantänemaßnahmen zur Sicherung des Herdenstatus durchführen.</div>
                    <div class="stage-question two-col-span">Wie wird der Gesundheitsstatus aufgenommener/zugekaufter Tiere überprüft?</div><div class="stage-question">Hinweis auf bestehende Dokumente</div>
                    <div class="stage-input two-col-span"><mat-form-field appearance="outline"><textarea matInput rows="2" formControlName="umsetzung"></textarea></mat-form-field></div>
                    <div class="stage-input"><mat-form-field appearance="outline"><input matInput formControlName="dokumentenhinweis" /></mat-form-field></div>
                </div>
            </div>

            <div class="subsection" formGroupName="transportSammelstellen">
                <h4>5.6 Transport und/oder Sammelstellen</h4>
                <div class="handlungsbedarf-inline"><span>Handlungsbedarf</span><mat-radio-group formControlName="handlungsbedarf"><mat-radio-button [value]="true">Ja</mat-radio-button><mat-radio-button [value]="false">Nein</mat-radio-button></mat-radio-group></div>
                <div class="stage-table">
                    <div class="stage-head stufe1">Stufe I</div><div class="stage-head stufe2">Stufe II</div><div class="stage-head stufe3">Stufe III</div>
                    <div class="stage-body two-col-span">Auf Transportwegen und Zwischenstationen Kontakt zu Tieren mit niedrigerem/unklarem Gesundheitsstatus vermeiden.</div>
                    <div class="stage-body">Kontakt zu Tieren mit niedrigerem oder unbekanntem Gesundheitsstatus ausschließen.</div>
                    <div class="stage-body">Tiere nur nach Quarantänemaßnahmen in den Betrieb aufnehmen.</div>
                    <div class="stage-question two-col-span">Gibt es Möglichkeiten, Informationen über den Gesundheitsstatus fremder Tiere einzuholen und Kontakt einzuschränken?</div><div class="stage-question">Hinweis auf bestehende Dokumente</div>
                    <div class="stage-input two-col-span"><mat-form-field appearance="outline"><textarea matInput rows="2" formControlName="umsetzung"></textarea></mat-form-field></div>
                    <div class="stage-input"><mat-form-field appearance="outline"><input matInput formControlName="dokumentenhinweis" /></mat-form-field></div>
                </div>
            </div>

            <div class="subsection" formGroupName="ausstellungenAuktionen">
                <h4>5.7 Ausstellungen und Auktionen</h4>
                <div class="handlungsbedarf-inline"><span>Handlungsbedarf</span><mat-radio-group formControlName="handlungsbedarf"><mat-radio-button [value]="true">Ja</mat-radio-button><mat-radio-button [value]="false">Nein</mat-radio-button></mat-radio-group></div>
                <div class="stage-table">
                    <div class="stage-head stufe1">Stufe I</div><div class="stage-head stufe2">Stufe II</div><div class="stage-head stufe3">Stufe III</div>
                    <div class="stage-body">Ausgestellte Tiere müssen mindestens geforderten Gesundheitsstatus bezüglich Tierseuchen haben.</div>
                    <div class="stage-body">Klinischer Gesundheitsstatus im Ursprungsbetrieb und definierter Gesundheitsstatus verringern Einschleppungsrisiko.</div>
                    <div class="stage-body">Spezifischer vereinbarter Gesundheitsstatus; ggf. Quarantäne und zusätzliche Untersuchungen vor Aufnahme.</div>
                    <div class="stage-question two-col-span">Welche Maßnahmen verhindern die Einschleppung von Erregern nach Veranstaltungen?</div><div class="stage-question">Hinweis auf bestehende Dokumente</div>
                    <div class="stage-input two-col-span"><mat-form-field appearance="outline"><textarea matInput rows="2" formControlName="umsetzung"></textarea></mat-form-field></div>
                    <div class="stage-input"><mat-form-field appearance="outline"><input matInput formControlName="dokumentenhinweis" /></mat-form-field></div>
                </div>
            </div>

            <div class="subsection" formGroupName="tierverkehrKliniken">
                <h4>5.8 Tierverkehr über Kliniken</h4>
                <div class="handlungsbedarf-inline"><span>Handlungsbedarf</span><mat-radio-group formControlName="handlungsbedarf"><mat-radio-button [value]="true">Ja</mat-radio-button><mat-radio-button [value]="false">Nein</mat-radio-button></mat-radio-group></div>
                <div class="stage-table">
                    <div class="stage-head stufe1">Stufe I</div><div class="stage-head stufe2">Stufe II</div><div class="stage-head stufe3">Stufe III</div>
                    <div class="stage-body two-col-span">Für zurückgeführte Tiere aus Kliniken Konzept zur Risikominimierung vorhalten, z. B. temporäre Trennung von der Stammherde.</div>
                    <div class="stage-body">Quarantänemaßnahmen im zurücknehmenden Betrieb sicherstellen.</div>
                    <div class="stage-question two-col-span">Welche Maßnahmen verhindern die Einschleppung von Erregern nach Klinikaufenthalt?</div><div class="stage-question">Hinweis auf bestehende Dokumente</div>
                    <div class="stage-input two-col-span"><mat-form-field appearance="outline"><textarea matInput rows="2" formControlName="umsetzung"></textarea></mat-form-field></div>
                    <div class="stage-input"><mat-form-field appearance="outline"><input matInput formControlName="dokumentenhinweis" /></mat-form-field></div>
                </div>
            </div>

            <div class="subsection" formGroupName="verkehrZuchtmaterial">
                <h4>5.9 Verkehr mit Zuchtmaterial</h4>
                <div class="handlungsbedarf-inline"><span>Handlungsbedarf</span><mat-radio-group formControlName="handlungsbedarf"><mat-radio-button [value]="true">Ja</mat-radio-button><mat-radio-button [value]="false">Nein</mat-radio-button></mat-radio-group></div>
                <div class="stage-table">
                    <div class="stage-head stufe1">Stufe I</div><div class="stage-head stufe2">Stufe II</div><div class="stage-head stufe3">Stufe III</div>
                    <div class="stage-body three-col-span">Zuchtmaterial muss von nach EU-Recht und/oder nationalem Tierzuchtrecht zugelassenen und regelmäßig amtlich kontrollierten Zuchtmaterialbetrieben stammen.</div>
                    <div class="stage-question two-col-span">Woher wird Tierzuchtmaterial (Samen, Eizellen, Embryonen) bezogen?</div><div class="stage-question">Hinweis auf bestehende Dokumente</div>
                    <div class="stage-input two-col-span"><mat-form-field appearance="outline"><textarea matInput rows="2" formControlName="umsetzung"></textarea></mat-form-field></div>
                    <div class="stage-input"><mat-form-field appearance="outline"><input matInput formControlName="dokumentenhinweis" /></mat-form-field></div>
                </div>
            </div>
        </div>
    </section>

    <section class="card section-nine" formGroupName="materialien">
        <div class="section-title-with-info">
            <h3>6 Materialien (Futtermittel, Gülle, Mist, Gärreste)</h3>
            <button mat-icon-button type="button" aria-label="Infos zu Materialien" (click)="openSection2Info(section6InfoDialog)">
                <mat-icon>info</mat-icon>
            </button>
        </div>

        <div class="section-nine-grid">
            <div class="subsection top" formGroupName="hygieneFutterTraenke">
                <h4>6.1 Hygiene bei Futter und Tränke</h4>
                <div class="handlungsbedarf-inline"><span>Handlungsbedarf</span><mat-radio-group formControlName="handlungsbedarf"><mat-radio-button [value]="true">Ja</mat-radio-button><mat-radio-button [value]="false">Nein</mat-radio-button></mat-radio-group></div>
                <div class="stage-table">
                    <div class="stage-head stufe1">Stufe I</div><div class="stage-head stufe2">Stufe II</div><div class="stage-head stufe3">Stufe III</div>
                    <div class="stage-body three-col-span">Futtertische, Futterkrippen und Tränken inkl. Zufahrten/Zugängen so gestalten, dass Verunreinigungen (Kot, Urin etc.) verhindert werden; regelmäßig reinigen.</div>
                    <div class="stage-body">Saubere und trockene Bereiche/Behälter für Futtermittellagerung bereitstellen.</div>
                    <div class="stage-body">Im Freien gelagerte Futtermittel/Silagen gegen Feuchtigkeit, Wildtierfraß und sonstige Kontaminationen abdecken.</div>
                    <div class="stage-body">Anschnittflächen von Silagen nach Entnahme wieder abnetzen/abdecken.</div>
                    <div class="stage-question two-col-span">Wie werden Futtermittel gelagert und vor nachteiliger Beeinflussung geschützt?</div><div class="stage-question">Hinweis auf bestehende Dokumente</div>
                    <div class="stage-input two-col-span"><mat-form-field appearance="outline"><textarea matInput rows="2" formControlName="umsetzung"></textarea></mat-form-field></div>
                    <div class="stage-input"><mat-form-field appearance="outline"><input matInput formControlName="dokumentenhinweis" /></mat-form-field></div>
                </div>
            </div>

            <div class="subsection top" formGroupName="verkehrTierausscheidungen">
                <h4>6.2 Verkehr von Tierausscheidungen</h4>
                <div class="handlungsbedarf-inline"><span>Handlungsbedarf</span><mat-radio-group formControlName="handlungsbedarf"><mat-radio-button [value]="true">Ja</mat-radio-button><mat-radio-button [value]="false">Nein</mat-radio-button></mat-radio-group></div>
                <div class="stage-table">
                    <div class="stage-head stufe1">Stufe I</div><div class="stage-head stufe2">Stufe II</div><div class="stage-head stufe3">Stufe III</div>
                    <div class="stage-body two-col-span">Futter nur nach angemessener Wartezeit von Flächen gewinnen, auf denen potenziell infektiöses Material ausgebracht wurde (gilt auch für eigenes Material).</div>
                    <div class="stage-body">Betriebsfremde Tierausscheidungen nur außerhalb der aufnehmenden Betriebsstätte lagern; Ausbringung auf Grünland möglichst vermeiden.</div>
                    <div class="stage-body">Ausbringung betriebsfremder Tierausscheidungen auf Futterflächen vermeiden.</div>
                    <div class="stage-question two-col-span">Werden betriebsfremde Tierausscheidungen eingesetzt und wenn ja, wo?</div><div class="stage-question">Hinweis auf bestehende Dokumente</div>
                    <div class="stage-input two-col-span"><mat-form-field appearance="outline"><textarea matInput rows="2" formControlName="umsetzung"></textarea></mat-form-field></div>
                    <div class="stage-input"><mat-form-field appearance="outline"><input matInput formControlName="dokumentenhinweis" /></mat-form-field></div>
                </div>
            </div>

            <div class="subsection" formGroupName="beweidungJungtiere">
                <h4>6.3 Beweidung Jungtiere</h4>
                <div class="handlungsbedarf-inline"><span>Handlungsbedarf</span><mat-radio-group formControlName="handlungsbedarf"><mat-radio-button [value]="true">Ja</mat-radio-button><mat-radio-button [value]="false">Nein</mat-radio-button></mat-radio-group></div>
                <div class="stage-table">
                    <div class="stage-head stufe1">Stufe I</div><div class="stage-head stufe2">Stufe II</div><div class="stage-head stufe3">Stufe III</div>
                    <div class="stage-body three-col-span">Jungtiere sollten nicht auf Flächen weiden, die im selben Jahr bereits von anderen Rindern beweidet wurden bzw. auf denen Wirtschaftsdünger ausgebracht wurde.</div>
                    <div class="stage-question two-col-span">Wie wird sichergestellt, dass Jungtiere nur auf geeigneten Flächen weiden?</div><div class="stage-question">Hinweis auf bestehende Dokumente</div>
                    <div class="stage-input two-col-span"><mat-form-field appearance="outline"><textarea matInput rows="2" formControlName="umsetzung"></textarea></mat-form-field></div>
                    <div class="stage-input"><mat-form-field appearance="outline"><input matInput formControlName="dokumentenhinweis" /></mat-form-field></div>
                </div>
            </div>

            <div class="subsection" formGroupName="kolostrummanagement">
                <h4>6.4 Kolostrummanagement</h4>
                <div class="handlungsbedarf-inline"><span>Handlungsbedarf</span><mat-radio-group formControlName="handlungsbedarf"><mat-radio-button [value]="true">Ja</mat-radio-button><mat-radio-button [value]="false">Nein</mat-radio-button></mat-radio-group></div>
                <div class="stage-table">
                    <div class="stage-head stufe1">Stufe I</div><div class="stage-head stufe2">Stufe II</div><div class="stage-head stufe3">Stufe III</div>
                    <div class="stage-body three-col-span">Frühzeitige und ausreichende Kolostrumversorgung, möglichst vom eigenen Muttertier; hygienisch gewinnen und verfüttern; wenn möglich kein Mischkolostrum.</div>
                    <div class="stage-question two-col-span">Wie wird eine qualitativ hochwertige Kolostrumversorgung gewährleistet?</div><div class="stage-question">Hinweis auf bestehende Dokumente</div>
                    <div class="stage-input two-col-span"><mat-form-field appearance="outline"><textarea matInput rows="2" formControlName="umsetzung"></textarea></mat-form-field></div>
                    <div class="stage-input"><mat-form-field appearance="outline"><input matInput formControlName="dokumentenhinweis" /></mat-form-field></div>
                </div>
            </div>
        </div>
    </section>

    <section class="card section-ten" formGroupName="ueberwachungTiergesundheit">
        <div class="section-title-with-info">
            <h3>7 Überwachung Tiergesundheit und weitere Maßnahmen zur Senkung des Infektionsdrucks</h3>
            <button mat-icon-button type="button" aria-label="Infos zu Überwachung Tiergesundheit" (click)="openSection2Info(section7InfoDialog)">
                <mat-icon>info</mat-icon>
            </button>
        </div>

        <div class="section-ten-grid">
            <div class="subsection top" formGroupName="tierbeobachtung">
                <h4>7.1 Tierbeobachtung</h4>
                <div class="handlungsbedarf-inline"><span>Handlungsbedarf</span><mat-radio-group formControlName="handlungsbedarf"><mat-radio-button [value]="true">Ja</mat-radio-button><mat-radio-button [value]="false">Nein</mat-radio-button></mat-radio-group></div>
                <div class="stage-table">
                    <div class="stage-head stufe1">Stufe I</div><div class="stage-head stufe2">Stufe II</div><div class="stage-head stufe3">Stufe III</div>
                    <div class="stage-body two-col-span">Tägliche Tierbeobachtung durch Tierhalter/beauftragte Person unter Einbeziehung aller verfügbaren Informationen zur Tiergesundheit.</div>
                    <div class="stage-body">Risikoorientierte intensivere Beobachtung einzelner Nutzungsgruppen (Kälber, frisch abgekalbte Tiere etc.) ist gewährleistet.</div>
                    <div class="stage-question two-col-span">Wie wird die tägliche Tierkontrolle sichergestellt?</div><div class="stage-question">Hinweis auf bestehende Dokumente</div>
                    <div class="stage-input two-col-span"><mat-form-field appearance="outline"><textarea matInput rows="2" formControlName="umsetzung"></textarea></mat-form-field></div>
                    <div class="stage-input"><mat-form-field appearance="outline"><input matInput formControlName="dokumentenhinweis" /></mat-form-field></div>
                </div>
            </div>

            <div class="subsection top" formGroupName="produktionsbiologischeDaten">
                <h4>7.2 Produktionsbiologische Daten</h4>
                <div class="handlungsbedarf-inline"><span>Handlungsbedarf</span><mat-radio-group formControlName="handlungsbedarf"><mat-radio-button [value]="true">Ja</mat-radio-button><mat-radio-button [value]="false">Nein</mat-radio-button></mat-radio-group></div>
                <div class="stage-table">
                    <div class="stage-head stufe1">Stufe I</div><div class="stage-head stufe2">Stufe II</div><div class="stage-head stufe3">Stufe III</div>
                    <div class="stage-body three-col-span">Erfassung und Auswertung produktionsbiologischer Daten (u. a. Abgänge, Aborte, Verluste, Fruchtbarkeitskennzahlen) regelmäßig durchführen und mit Tierärzten/Fachkräften analysieren.</div>
                    <div class="stage-question two-col-span">Wie werden produktionsbiologische Daten und Ursachen von Tierverlusten erfasst und ausgewertet?</div><div class="stage-question">Hinweis auf bestehende Dokumente</div>
                    <div class="stage-input two-col-span"><mat-form-field appearance="outline"><textarea matInput rows="2" formControlName="umsetzung"></textarea></mat-form-field></div>
                    <div class="stage-input"><mat-form-field appearance="outline"><input matInput formControlName="dokumentenhinweis" /></mat-form-field></div>
                </div>
            </div>

            <div class="subsection" formGroupName="fachlicheBegleitungTiergesundheitsbesuche">
                <h4>7.3 Fachliche Begleitung und Tiergesundheitsbesuche</h4>
                <div class="handlungsbedarf-inline"><span>Handlungsbedarf</span><mat-radio-group formControlName="handlungsbedarf"><mat-radio-button [value]="true">Ja</mat-radio-button><mat-radio-button [value]="false">Nein</mat-radio-button></mat-radio-group></div>
                <div class="stage-table">
                    <div class="stage-head stufe1">Stufe I</div><div class="stage-head stufe2">Stufe II</div><div class="stage-head stufe3">Stufe III</div>
                    <div class="stage-body">Jeder Tierhalter muss seinen Bestand tierärztlich betreuen lassen.</div>
                    <div class="stage-body two-col-span">Tierärztliche Betreuung umfasst Diagnostik, Behandlung, Beratung sowie Tiergesundheitsbesuche inkl. Seuchenprävention und Dokumentation der Ergebnisse.</div>
                    <div class="stage-question two-col-span">Wie oft erfolgen tierärztliche Bestandsuntersuchungen und liegen Aufzeichnungen vor?</div><div class="stage-question">Hinweis auf bestehende Dokumente</div>
                    <div class="stage-input two-col-span"><mat-form-field appearance="outline"><textarea matInput rows="2" formControlName="umsetzung"></textarea></mat-form-field></div>
                    <div class="stage-input"><mat-form-field appearance="outline"><input matInput formControlName="dokumentenhinweis" /></mat-form-field></div>
                </div>
            </div>

            <div class="subsection" formGroupName="hinzuziehenExpertenwissen">
                <h4>7.4 Hinzuziehen von Expertenwissen</h4>
                <div class="handlungsbedarf-inline"><span>Handlungsbedarf</span><mat-radio-group formControlName="handlungsbedarf"><mat-radio-button [value]="true">Ja</mat-radio-button><mat-radio-button [value]="false">Nein</mat-radio-button></mat-radio-group></div>
                <div class="stage-table">
                    <div class="stage-head stufe1">Stufe I</div><div class="stage-head stufe2">Stufe II</div><div class="stage-head stufe3">Stufe III</div>
                    <div class="stage-body two-col-span">Frühzeitiges Hinzuziehen von Fachberatern zur Ursachenfeststellung und Strategieentwicklung trägt zum Erhalt/Verbesserung der Tiergesundheit bei.</div>
                    <div class="stage-body">Regelmäßige, nicht anlassbezogene Einbindung von Fachleuten für Managementsysteme.</div>
                    <div class="stage-question two-col-span">Welche Fachberater werden hinzugezogen und wie wird Empfohlenes umgesetzt?</div><div class="stage-question">Hinweis auf bestehende Dokumente</div>
                    <div class="stage-input two-col-span"><mat-form-field appearance="outline"><textarea matInput rows="2" formControlName="umsetzung"></textarea></mat-form-field></div>
                    <div class="stage-input"><mat-form-field appearance="outline"><input matInput formControlName="dokumentenhinweis" /></mat-form-field></div>
                </div>
            </div>

            <div class="subsection" formGroupName="frueherkennungTierseuchenTierkrankheiten">
                <h4>7.5 Früherkennung von Tierseuchen und Tierkrankheiten</h4>
                <div class="handlungsbedarf-inline"><span>Handlungsbedarf</span><mat-radio-group formControlName="handlungsbedarf"><mat-radio-button [value]="true">Ja</mat-radio-button><mat-radio-button [value]="false">Nein</mat-radio-button></mat-radio-group></div>
                <div class="stage-table">
                    <div class="stage-head stufe1">Stufe I</div><div class="stage-head stufe2">Stufe II</div><div class="stage-head stufe3">Stufe III</div>
                    <div class="stage-body">Bei Verdachtsanzeichen (Leistungseinbruch, Fieber, Aborte, Todesfälle) Tierarzt frühzeitig hinzuziehen.</div>
                    <div class="stage-body">Über rechtliche Vorgaben hinaus besondere Untersuchungen zur Früherkennung durchführen.</div>
                    <div class="stage-body">Ursachen unverzüglich tierärztlich abklären und weitere Maßnahmen veranlassen.</div>
                    <div class="stage-question two-col-span">Wie wird mit Veränderungen umgegangen und ab wann wird der Tierarzt hinzugezogen?</div><div class="stage-question">Hinweis auf bestehende Dokumente</div>
                    <div class="stage-input two-col-span"><mat-form-field appearance="outline"><textarea matInput rows="2" formControlName="umsetzung"></textarea></mat-form-field></div>
                    <div class="stage-input"><mat-form-field appearance="outline"><input matInput formControlName="dokumentenhinweis" /></mat-form-field></div>
                </div>
            </div>

            <div class="subsection" formGroupName="weitereMassnahmenInfektionsdruck">
                <h4>7.6 Weitere Maßnahmen zur Senkung des Infektionsdrucks</h4>
                <div class="handlungsbedarf-inline"><span>Handlungsbedarf</span><mat-radio-group formControlName="handlungsbedarf"><mat-radio-button [value]="true">Ja</mat-radio-button><mat-radio-button [value]="false">Nein</mat-radio-button></mat-radio-group></div>
                <div class="stage-table">
                    <div class="stage-head stufe1">Stufe I</div><div class="stage-head stufe2">Stufe II</div><div class="stage-head stufe3">Stufe III</div>
                    <div class="stage-body">Planmäßiges Schädlingsmonitoring, ggf. Bekämpfung und Erfolgskontrolle.</div>
                    <div class="stage-body">Dokumentation der Schädlingsbekämpfung.</div>
                    <div class="stage-body">Planmäßige Schädlingsbekämpfung durch geprüfte Fachleute inklusive Dokumentation.</div>
                    <div class="stage-question two-col-span">Wie erfolgt die Schädlingsbekämpfung auf dem Betrieb?</div><div class="stage-question">Hinweis auf bestehende Dokumente</div>
                    <div class="stage-input two-col-span"><mat-form-field appearance="outline"><textarea matInput rows="2" formControlName="umsetzung"></textarea></mat-form-field></div>
                    <div class="stage-input"><mat-form-field appearance="outline"><input matInput formControlName="dokumentenhinweis" /></mat-form-field></div>
                </div>
            </div>

            <div class="subsection" formGroupName="reinigungDesinfektion">
                <h4>7.7 Reinigung und Desinfektion (s. DVG-Liste)</h4>
                <div class="handlungsbedarf-inline"><span>Handlungsbedarf</span><mat-radio-group formControlName="handlungsbedarf"><mat-radio-button [value]="true">Ja</mat-radio-button><mat-radio-button [value]="false">Nein</mat-radio-button></mat-radio-group></div>
                <div class="stage-table">
                    <div class="stage-head stufe1">Stufe I</div><div class="stage-head stufe2">Stufe II</div><div class="stage-head stufe3">Stufe III</div>
                    <div class="stage-body">Anlassbezogene Reinigung von Betriebsteilen verringert lokal die Keimbelastung.</div>
                    <div class="stage-body two-col-span">Planmäßige Reinigung und anlassbezogene Desinfektion reduzieren Krankheitserreger und Übertragungsrisiko gezielt.</div>
                    <div class="stage-body">Planmäßige Desinfektion im Betrieb zur generellen Keimreduktion.</div>
                    <div class="stage-question two-col-span">In welchen Fällen und wie oft werden Reinigungs-/Desinfektionsmaßnahmen durchgeführt?</div><div class="stage-question">Hinweis auf bestehende Dokumente</div>
                    <div class="stage-input two-col-span"><mat-form-field appearance="outline"><textarea matInput rows="2" formControlName="umsetzung"></textarea></mat-form-field></div>
                    <div class="stage-input"><mat-form-field appearance="outline"><input matInput formControlName="dokumentenhinweis" /></mat-form-field></div>
                </div>
            </div>
        </div>
    </section>

    <section class="card map-anhang-section" formGroupName="mapAnhangParatuberkulose">
        <div class="section-title-with-info">
            <h3>Anhang</h3>
        </div>
        <h4>Paratuberkulose</h4>

        <div class="map-meta-row">
            <mat-checkbox formControlName="initialPlan">Initial-Plan bei Einstieg in das Verfahren</mat-checkbox>
            <mat-form-field appearance="outline">
                <mat-label>Evaluation-Nr.</mat-label>
                <input matInput formControlName="evaluationsNr" />
            </mat-form-field>
        </div>

        <div class="map-table-wrap" formArrayName="jahreswerte">
            <table class="map-table">
                <thead>
                    <tr>
                        <th>Jahr</th>
                        <th>Getestete Tiere</th>
                        <th>Positive (Reagenten)</th>
                        <th>% MAP-positiv</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let row of paratuberkuloseRows.controls; let i = index" [formGroupName]="i">
                        <td><input matInput type="number" formControlName="jahr" placeholder="2026" /></td>
                        <td><input matInput type="number" min="0" formControlName="getestet" /></td>
                        <td><input matInput type="number" min="0" formControlName="positiv" /></td>
                        <td>{{ getParatuberkuloseProzent(row.value) | number: '1.0-1' }}%</td>
                        <td>
                            <button mat-icon-button type="button" (click)="removeParatuberkuloseRow(i)" [disabled]="paratuberkuloseRows.length <= 1">
                                <mat-icon>delete</mat-icon>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="section-actions">
            <button mat-stroked-button type="button" (click)="addParatuberkuloseRow()">
                Jahr hinzufügen
            </button>
            <button mat-raised-button color="primary" type="button" (click)="openParatuberkulosePreview(paratuberkulosePreviewDialog)">
                Preview
            </button>
        </div>

        <div class="map-next-steps" formGroupName="naechsteSchritte">
            <h4>2. Festlegung der nächsten Schritte</h4>
            <h5>2.1 Nächste Überprüfung der MAP-Befallsrate in der Herde</h5>
            <div class="map-next-steps-row">
                <mat-form-field appearance="outline">
                    <mat-label>Terminierung</mat-label>
                    <input matInput [matDatepicker]="mapNextStepPicker" formControlName="terminierung" />
                    <mat-datepicker-toggle matSuffix [for]="mapNextStepPicker"></mat-datepicker-toggle>
                    <mat-datepicker #mapNextStepPicker></mat-datepicker>
                </mat-form-field>
                <mat-checkbox formControlName="einzelmilchproben">Einzelmilchprobe(n)</mat-checkbox>
                <mat-checkbox formControlName="einzelblutproben">Einzelblutprobe(n)</mat-checkbox>
            </div>
        </div>

        <div class="map-infektion" formGroupName="erkennungBestandsinfektion">
            <h4>3. Erkennung der Bestandsinfektion</h4>
            <div class="map-infektion-block" formGroupName="pflicht31">
                <h5>3.1 Pflichtuntersuchung</h5>
                <div class="map-next-steps-row">
                    <mat-form-field appearance="outline">
                        <mat-label>Serologie / Antikörper</mat-label>
                        <input matInput formControlName="serologieAntikoerper" />
                    </mat-form-field>
                    <mat-checkbox formControlName="sammelmilchproben">Sammelmilchprobe(n)</mat-checkbox>
                    <mat-form-field appearance="outline">
                        <mat-label>Datum</mat-label>
                        <input matInput [matDatepicker]="pflicht31DatumPicker" formControlName="sammelmilchDatum" />
                        <mat-datepicker-toggle matSuffix [for]="pflicht31DatumPicker"></mat-datepicker-toggle>
                        <mat-datepicker #pflicht31DatumPicker></mat-datepicker>
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                        <mat-label>Ergebnis</mat-label>
                        <input matInput formControlName="sammelmilchErgebnis" />
                    </mat-form-field>
                    <mat-checkbox formControlName="einzeltierproben">Einzeltierprobe(n)</mat-checkbox>
                </div>

                <div class="map-table-wrap" formGroupName="jahre">
                    <table class="map-table">
                        <thead>
                            <tr>
                                <th></th>
                                <th *ngFor="let year of infektionsJahre">{{ year.label }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>bekannte MAP-Reagenten (N)</td>
                                <td *ngFor="let year of infektionsJahre" [formGroupName]="year.key">
                                    <input matInput type="number" formControlName="bekannteMapReagenten" />
                                </td>
                            </tr>
                            <tr>
                                <td>entfernte MAP-Reagenten (N)</td>
                                <td *ngFor="let year of infektionsJahre" [formGroupName]="year.key">
                                    <input matInput type="number" formControlName="entfernteMapReagenten" />
                                </td>
                            </tr>
                            <tr>
                                <td>= verbliebene MAP-Reagenten (N)</td>
                                <td *ngFor="let year of infektionsJahre" [formGroupName]="year.key">
                                    <input matInput type="number" formControlName="verbliebeneMapReagenten" />
                                </td>
                            </tr>
                            <tr>
                                <td>Datum Statuskontrolle</td>
                                <td *ngFor="let year of infektionsJahre" [formGroupName]="year.key">
                                    <input matInput formControlName="datumStatuskontrolle" />
                                </td>
                            </tr>
                            <tr>
                                <td>NEG/Fraglich (N)</td>
                                <td *ngFor="let year of infektionsJahre" [formGroupName]="year.key">
                                    <input matInput type="number" formControlName="negFraglich" />
                                </td>
                            </tr>
                            <tr>
                                <td>POS (N)</td>
                                <td *ngFor="let year of infektionsJahre" [formGroupName]="year.key">
                                    <input matInput type="number" formControlName="pos" />
                                </td>
                            </tr>
                            <tr>
                                <td>MAP-Reagenten (N)</td>
                                <td *ngFor="let year of infektionsJahre" [formGroupName]="year.key">
                                    <input matInput type="number" formControlName="mapReagenten" />
                                </td>
                            </tr>
                            <tr>
                                <td>Anteil MAP-Reagenten [%]</td>
                                <td *ngFor="let year of infektionsJahre" [formGroupName]="year.key">
                                    <input matInput type="number" formControlName="anteilMapReagenten" />
                                </td>
                            </tr>
                            <tr>
                                <td>Anzahl Tiere [MAP POS]</td>
                                <td *ngFor="let year of infektionsJahre" [formGroupName]="year.key">
                                    <input matInput type="number" formControlName="anzahlTiereMapPos" />
                                </td>
                            </tr>
                            <tr>
                                <td>Anzahl Zucht-Tiere &gt; 24 Mon</td>
                                <td *ngFor="let year of infektionsJahre" [formGroupName]="year.key">
                                    <input matInput type="number" formControlName="anzahlZuchtTiere24Mon" />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div class="map-infektion-block" formArrayName="pflicht32">
                <h5>3.2 Pflichtuntersuchung</h5>
                <div class="map-table-wrap">
                    <table class="map-table map-pflicht32-table">
                        <thead>
                            <tr>
                                <th>Datum</th>
                                <th>Ergebnis</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let row of pflicht32Rows.controls; let i = index" [formGroupName]="i">
                                <td>
                                    <mat-form-field appearance="outline" class="map-date-field">
                                        <input matInput [matDatepicker]="pflicht32Picker" formControlName="datum" />
                                        <mat-datepicker-toggle matSuffix [for]="pflicht32Picker"></mat-datepicker-toggle>
                                        <mat-datepicker #pflicht32Picker></mat-datepicker>
                                    </mat-form-field>
                                </td>
                                <td><input matInput formControlName="ergebnis" /></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="section-actions">
                    <button mat-stroked-button type="button" (click)="addPflicht32Row()">Zeile hinzufügen</button>
                </div>
            </div>
        </div>

        <div class="map-infektion-block" formArrayName="handlungstabelle">
            <h5>Beschreibung der Schwachstelle / Handlungsempfehlung / Erledigt-Ergänzende Unterlagen</h5>
            <div class="map-table-wrap">
                <table class="map-table map-handlung-table">
                    <thead>
                        <tr>
                            <th>Nr.</th>
                            <th>Beschreibung der Schwachstelle</th>
                            <th>Handlungsempfehlung</th>
                            <th>Erledigt / Ergänzende Unterlagen</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let row of handlungRows.controls; let i = index" [formGroupName]="i">
                            <td><input matInput formControlName="nr" /></td>
                            <td><textarea matInput rows="2" formControlName="schwachstelle"></textarea></td>
                            <td><textarea matInput rows="2" formControlName="handlungsempfehlung"></textarea></td>
                            <td><textarea matInput rows="2" formControlName="erledigtUnterlagen"></textarea></td>
                            <td>
                                <button
                                    mat-icon-button
                                    type="button"
                                    (click)="removeHandlungRow(i)"
                                    [disabled]="handlungRows.length <= 1"
                                >
                                    <mat-icon>delete</mat-icon>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="section-actions">
                <button mat-stroked-button type="button" (click)="addHandlungRow()">Zeile hinzufügen</button>
            </div>
        </div>
    </section>

    <div class="workflow-row card">
        <div class="workflow-status">
            <strong>Status:</strong> {{ getStatusLabel() }}
            <span *ngIf="isSaving"> - wird gespeichert...</span>
        </div>
        <div class="workflow-actions">
            <kiene-sign-button
                [disabled]="!bsId || isSaving || isAlreadySigned()"
                [buttonText]="signButtonLabel"
                [kuid]="planKuid"
                [tierarzt_id]="tierarztIdForSign"
                [kunde_id]="kundeIdForSign"
                (kuid)="persistKuidToPlan($event)"
                (signDialogClosed)="onSignDialogClosed()"
            ></kiene-sign-button>
            <button
                *kienePermission="[110024]"
                mat-raised-button
                color="accent"
                type="button"
                (click)="abschliessen()"
                [disabled]="!bsId || isSaving || statusId === 232 || statusId === 250 || statusId === 251"
            >
                Abschließen
            </button>
            <button
                *ngIf="statusId === 251 && localStorageService.hasPermission(110026)"
                mat-stroked-button
                type="button"
                (click)="setBeantragtStatus(231)"
                [disabled]="!bsId || isSaving"
            >
                Zurück auf erstellt
            </button>
        </div>
    </div>

    <ng-template #paratuberkulosePreviewDialog>
        <h2 mat-dialog-title>Preview - Paratuberkulose Verlauf</h2>
        <mat-dialog-content>
            <google-chart
                *ngIf="mapChartHasData; else noMapChartData"
                style="width: 100%; min-height: 420px"
                [type]="mapChartType"
                [columns]="mapChartColumns"
                [data]="mapChartData"
                [options]="mapChartOptions"
            >
            </google-chart>
            <ng-template #noMapChartData>
                <div style="min-height: 420px; display: flex; align-items: center; justify-content: center; color: #6b7280; font-size: 18px">
                    Keine Daten vorhanden
                </div>
            </ng-template>
        </mat-dialog-content>
        <mat-dialog-actions align="end">
            <button mat-button mat-dialog-close>Schließen</button>
        </mat-dialog-actions>
    </ng-template>

    <ng-template #section2InfoDialog>
        <div class="section2-info-dialog">
            <h2 mat-dialog-title>KENNTNISSE, SENSIBILISIERUNG, UNTERWEISUNGEN</h2>
            <mat-dialog-content>
                <p>
                    Der Eintrag von Tierseuchenerregern durch Menschen stellt eine große Gefahr für den Tierbestand dar.
                    Deshalb muss der Tierhalter dafür sorgen, dass betriebseigene Biosicherheitsvorgaben formuliert,
                    kommuniziert und umgesetzt werden.
                </p>

                <h3>Rechtliche Bestimmungen für Tierhalter / Unternehmer</h3>
                <ul>
                    <li>
                        ist verantwortlich für die Gesundheit der gehaltenen Tiere (Art. 10 VO (EU) 2016/429)
                    </li>
                    <li>
                        ist zuständig für die Minimierung des Risikos der Ausbreitung von Seuchen durch geeignete
                        Maßnahmen zum Schutz vor biologischen Gefahren (Art. 10 VO (EU) 2016/429)
                    </li>
                    <li>hat zu verhindern, dass Tierseuchen in oder aus dem Bestand einge-/verschleppt werden (§ 3 TierGesG)</li>
                    <li>
                        hat sicherzustellen, dass der Betrieb von einem Tierarzt besucht wird, wenn dies risikobedingt
                        angezeigt ist (Art. 25 VO (EU) 2016/429)
                    </li>
                    <li>
                        muss über angemessene Kenntnisse u. a. über gute Tierhaltungspraxis, Tierseuchen, Schutz vor
                        biologischen Gefahren verfügen (Art. 11 VO (EU) 2016/429); muss sachkundig in Hinblick auf die
                        Übertragbarkeit anzeigepflichtiger Tierseuchen sein (§ 3 TierGesG)
                    </li>
                    <li>
                        muss über Kenntnisse über angemessene Ernährung, Pflege und verhaltensgerechte Unterbringung
                        verfügen (§ 2 TierSchG)
                    </li>
                </ul>

                <h3>Rechtliche Bestimmungen für Personal des Betriebes</h3>
                <ul>
                    <li>
                        angemessene Kenntnisse u. a. über gute Tierhaltungspraxis, Tierseuchen, Schutz vor biologischen
                        Gefahren (Art. 11 VO (EU) 2016/429)
                    </li>
                    <li>
                        Kenntnisse über angemessene Ernährung, Pflege und verhaltensgerechte Unterbringung (§ 2 TierSchG)
                    </li>
                </ul>

                <h3>Rechtliche Bestimmungen für Angehörige der mit Tieren befassten Berufe</h3>
                <p>(Besamungstechniker, Klauenpfleger, Milchkontrolleur, Viehhändler, Fütterungsberater etc.)</p>
                <ul>
                    <li>ergreifen geeignete Maßnahmen zum Schutz vor biologischen Gefahren (Art. 10 VO (EU) 2016/429)</li>
                    <li>
                        verfügen über angemessene Kenntnisse u. a. über gute Tierhaltungspraxis, Tierseuchen, Schutz vor
                        biologischen Gefahren (Art. 11 VO (EU) 2016/429)
                    </li>
                </ul>

                <h3>Rechtliche Bestimmungen für Tierärzte</h3>
                <ul>
                    <li>
                        Tierärzte ergreifen geeignete Maßnahmen zum Schutz vor biologischen Gefahren zur Minimierung des
                        Risikos der Ausbreitung von Seuchen (Art. 12 VO (EU) 2016/429)
                    </li>
                    <li>
                        Mindestanforderungen der Bundestierärztekammer zur Biosicherheit für Tierärztinnen und Tierärzte
                        beim Besuch von Tierhaltungen:
                        <a
                            href="https://www.bundestieraerztekammer.de/tieraerzte/leitlinien"
                            target="_blank"
                            rel="noopener noreferrer"
                            >https://www.bundestieraerztekammer.de/tieraerzte/leitlinien</a
                        >
                    </li>
                </ul>
            </mat-dialog-content>
            <mat-dialog-actions align="end">
                <button mat-stroked-button mat-dialog-close type="button">Schließen</button>
            </mat-dialog-actions>
        </div>
    </ng-template>

    <ng-template #section3InfoDialog>
        <div class="section2-info-dialog">
            <h2 mat-dialog-title>BAULICHE GEGEBENHEITEN, LAGESKIZZE</h2>
            <mat-dialog-content>
                <p>
                    Der Eintrag von Krankheitserregern durch Menschen, Wild- und Haustiere stellt eine Gefahr für den
                    Tierbestand dar. Deshalb muss der Tierhalter dafür sorgen, dass physische Barrieren den direkten
                    Zugang zum Tierbestand und zu Futterlagern weitestgehend einschränken. Für einen Überblick ist die
                    Erstellung einer Lageskizze des Betriebes sinnvoll.
                </p>

                <h3>Rechtliche Bestimmungen für bauliche Gegebenheiten</h3>
                <ul>
                    <li>
                        Physische Maßnahmen zum Schutz vor biologischen Gefahren sind zu ergreifen (Art. 10 VO (EU)
                        2016/429).
                    </li>
                    <li>
                        Ställe müssen mit Vorrichtungen ausgestattet sein, die jederzeit eine zur Inaugenscheinnahme der
                        Tiere ausreichende Beleuchtung und einen Zugriff auf alle Nutztiere durch die mit der Fütterung und
                        Pflege betrauten Personen ermöglichen (§ 3 Abs. 3 Nr. 1 TierSchNutztV).
                    </li>
                    <li>
                        In jedem rinderhaltenden Betrieb muss eine Krankenbucht/-stall jederzeit verfügbar sein (vgl.
                        Niedersächsische Tierschutzleitlinie für die Milchkuhhaltung, Niedersächsische Tierschutzleitlinie
                        für die Mastrinderhaltung, Niedersächsischer Leitfaden für einen tierschutzgerechten Umgang mit
                        kranken und verletzten Rindern).
                    </li>
                    <li>
                        Ggf. werden Verfahren zu Quarantäne- und Isolationsmaßnahmen oder Maßnahmen zur Absonderung von neu
                        eingestallten oder kranken Tieren beschrieben (Art. 10 VO (EU) 2016/429).
                    </li>
                </ul>
            </mat-dialog-content>
            <mat-dialog-actions align="end">
                <button mat-stroked-button mat-dialog-close type="button">Schließen</button>
            </mat-dialog-actions>
        </div>
    </ng-template>

    <ng-template #lageplanLegendeDialog>
        <div class="lageplan-legende-dialog">
            <h2 mat-dialog-title>Lageplan-Legende</h2>
            <mat-dialog-content>
                <img
                    src="assets/biosicherheitsplanschwein/biosicherheitsplanschwein_legende_lageskizze.png"
                    alt="Lageplan Legende"
                />
            </mat-dialog-content>
            <mat-dialog-actions align="end">
                <button mat-stroked-button type="button" (click)="openLageplanLegendePopout()">Pop-out</button>
                <button mat-stroked-button mat-dialog-close type="button">Schließen</button>
            </mat-dialog-actions>
        </div>
    </ng-template>

    <ng-template #sketchPreviewDialog>
        <div class="lageplan-legende-dialog">
            <h2 mat-dialog-title>{{ previewFileName }}</h2>
            <mat-dialog-content>
                <img *ngIf="previewIsImage" [src]="previewUrl" alt="Dokument Vorschau" />
                <iframe *ngIf="previewIsPdf" [src]="previewUrl" title="PDF Vorschau"></iframe>
                <div class="preview-fallback" *ngIf="!previewIsImage && !previewIsPdf">
                    <p>Für diesen Dateityp ist keine direkte Vorschau verfügbar.</p>
                    <a [href]="previewDownloadUrl" target="_blank" rel="noopener noreferrer">Datei in neuem Tab öffnen</a>
                </div>
            </mat-dialog-content>
            <mat-dialog-actions align="end">
                <button mat-stroked-button mat-dialog-close type="button">Schließen</button>
            </mat-dialog-actions>
        </div>
    </ng-template>

    <ng-template #section4InfoDialog>
        <div class="section2-info-dialog">
            <h2 mat-dialog-title>PERSONEN UND FAHRZEUGVERKEHR</h2>
            <mat-dialog-content>
                <p>
                    Personen und Fahrzeuge stellen als belebte und unbelebte Vektoren eine Möglichkeit zur Verschleppung
                    von Krankheitserregern dar. Daher sollte viel Wert auf eine ordentliche Reinigung und Desinfektion
                    gelegt werden. Zusätzlich wird an Sicherheit gewonnen, indem Lauf- und Fahrwege optimiert werden.
                </p>

                <h3>Rechtliche Bestimmungen für Personen- und Fahrzeugverkehr</h3>
                <ul>
                    <li>
                        Ggf. Verfahren beschreiben, die regeln, wie Fahrzeuge und Personen in einen Betrieb gelangen und
                        ihn verlassen (Art. 10 VO (EU) 2016/429).
                    </li>
                    <li>
                        Viehtransportfahrzeuge müssen so beschaffen sein, dass tierische Abgänge, Einstreu oder Futter
                        während des Transportes nicht heraussickern oder herausfallen können, und müssen leicht zu reinigen
                        und zu desinfizieren sein. Reinigung und Desinfektion von gewerblichen
                        Viehtransportfahrzeugen/-behältnissen und Gerätschaften müssen nach jedem Transport, spätestens
                        jedoch nach Ablauf von 29 Stunden seit Beginn des Transportes erfolgen (Ausnahme nichtgewerbliche
                        Viehtransportfahrzeuge für Transport von eigenem Vieh). Viehtransportfahrzeuge, mit denen Vieh zu
                        Viehladestellen, Sammelstellen oder Schlachtstätten verbracht worden ist, müssen, bevor sie diese
                        verlassen, gereinigt und desinfiziert werden (§§ 1 und 17 VVVO).
                    </li>
                </ul>
            </mat-dialog-content>
            <mat-dialog-actions align="end">
                <button mat-stroked-button mat-dialog-close type="button">Schließen</button>
            </mat-dialog-actions>
        </div>
    </ng-template>

    <ng-template #section5InfoDialog>
        <div class="section2-info-dialog">
            <h2 mat-dialog-title>TIERVERKEHR</h2>
            <mat-dialog-content>
                <p>
                    Durch einen gut geplanten Tierverkehr kann das Risiko der Erregerverschleppung erheblich verringert
                    werden. Daher muss beim Verbringen von Rindern auf ein gutes Management sowie auf Reinigung und
                    Desinfektion der Fahrzeuge geachtet werden.
                </p>
                <h3>Rechtliche Bestimmungen zum Tierverkehr</h3>
                <ul>
                    <li>Ggf. Verfahren beschreiben, die regeln, wie Tiere in einen Betrieb gelangen und ihn verlassen (Art. 10 VO (EU) 2016/429).</li>
                    <li>Ggf. Bedingungen für die Verbringung von Tieren und die Überführung in einen Betrieb unter Berücksichtigung der Risiken beschreiben (Art. 10 VO (EU) 2016/429).</li>
                    <li>Ggf. Verfahren zu Quarantäne und Isolation oder Maßnahmen zur Absonderung neu eingestallter/kranker Tiere beschreiben (Art. 10 VO (EU) 2016/429).</li>
                    <li>Bis zur Abholung tote Tiere getrennt und geschützt lagern; nach Abholung Behältnisse/Örtlichkeiten unverzüglich reinigen und desinfizieren (TierNebG §10).</li>
                    <li>Hinweise zur Reinigung und Desinfektion siehe DVG-Liste für Desinfektionsmittel.</li>
                </ul>
            </mat-dialog-content>
            <mat-dialog-actions align="end">
                <button mat-stroked-button mat-dialog-close type="button">Schließen</button>
            </mat-dialog-actions>
        </div>
    </ng-template>

    <ng-template #section6InfoDialog>
        <div class="section2-info-dialog">
            <h2 mat-dialog-title>MATERIALIEN (FUTTERMITTEL, GÜLLE, MIST, GÄRRESTE)</h2>
            <mat-dialog-content>
                <p>
                    Es müssen ausreichende Maßnahmen ergriffen werden, um den Eintrag von Seuchenerregern über Einstreu
                    und Futtermittel zu verhindern. Um die Verbreitung von Erregern über Tierausscheidungen zu verhindern,
                    muss eine sichere Handhabung und Lagerung gewährleistet werden.
                </p>
                <h3>Rechtliche Bestimmungen zum Umgang mit Materialien</h3>
                <ul>
                    <li>Unternehmer sind verantwortlich für die Gesundheit der gehaltenen Tiere und Erzeugnisse und ergreifen geeignete Maßnahmen zum Schutz vor biologischen Gefahren (Art. 10 VO (EU) 2016/429).</li>
                    <li>Tierische Nebenprodukte sind so zu handhaben, dass Leben oder Gesundheit anderer Tiere nicht gefährdet werden (§ 2a TierNebG).</li>
                </ul>
            </mat-dialog-content>
            <mat-dialog-actions align="end">
                <button mat-stroked-button mat-dialog-close type="button">Schließen</button>
            </mat-dialog-actions>
        </div>
    </ng-template>

    <ng-template #section7InfoDialog>
        <div class="section2-info-dialog">
            <h2 mat-dialog-title>ÜBERWACHUNG TIERGESUNDHEIT UND WEITERE MASSNAHMEN ZUR SENKUNG DES INFEKTIONSDRUCKS</h2>
            <mat-dialog-content>
                <p>
                    Um Veränderungen und Krankheiten bei den Tieren möglichst früh zu erkennen, ist eine tägliche
                    betriebseigene Kontrolle mit anschließender Dokumentation unerlässlich. Das Hinzuziehen eines
                    Tierarztes und weiterführende Untersuchungen geben Aufschluss über Ursachen und können für die
                    frühzeitige Erkennung einer Tierseuche entscheidend sein.
                </p>
                <h3>Rechtliche Bestimmungen für betriebseigene Kontrollen und Aufzeichnungen</h3>
                <ul>
                    <li>Überwachungspflicht des Unternehmers bzgl. Gesundheit, Verhalten, Produktionsparameter und Mortalität (Art. 24 VO (EU) 2016/429).</li>
                    <li>Unverzügliche Maßnahmen, Absonderung und ggf. Hinzuziehung eines Tierarztes (§ 4 Abs. 1 Nr. 3 TierSchNutztV).</li>
                    <li>Mindestens tägliche Kontrolle des Befindens und Entfernung toter Tiere (§ 4 Abs. 1 Satz 1 Nr. 2 TierSchNutztV).</li>
                    <li>Aufzeichnungen über tägliche Bestandskontrolle, Behandlungen sowie Anzahl/Ursache von Tierverlusten (§ 4 Abs. 2 TierSchNutztV).</li>
                    <li>Pflicht zur Führung von Aufzeichnungen, z. B. über Tiergesundheitsbesuche (Art. 102 VO (EU) 2016/429).</li>
                    <li>Vorgeschriebene betriebliche Eigenkontrollen (Tierschutzindikatoren) (§ 11 Abs. 8 TierSchG).</li>
                </ul>
                <h3>Rechtliche Bestimmungen für tierärztliche Bestandsbetreuung</h3>
                <ul>
                    <li>Zusammenarbeit mit Veterinärbehörde und bestandsbetreuenden Tierärzten bei Prävention/Bekämpfung (Art. 10 VO (EU) 2016/429).</li>
                    <li>Durchführung regelmäßiger Tiergesundheitsbesuche (Art. 25 VO (EU) 2016/429).</li>
                </ul>
            </mat-dialog-content>
            <mat-dialog-actions align="end">
                <button mat-stroked-button mat-dialog-close type="button">Schließen</button>
            </mat-dialog-actions>
        </div>
    </ng-template>
</div>
